/* eslint-disable max-len */

export const Learnsets: import('../../../sim/dex-species').ModdedLearnsetDataTable = {
	pikachu: {
		learnset: {
			babydolleyes: ["8T"],
			calmmind: ["8T"],
			chargebeam: ["8T"],
			irontail: ["8T", "8L37"],
			playrough: ["8T"],
			quickattack: ["8L5"],
			rest: ["8T"],
			rocksmash: ["8T"],
			spark: ["8L21"],
			swift: ["8T", "8L15"],
			thunder: ["8L47"],
			thunderbolt: ["8T", "8L29"],
			thunderpunch: ["8T"],
			thundershock: ["8L1"],
			thunderwave: ["8L9"],
			volttackle: ["8T"],
			wildcharge: ["8T"],
		},
	},
	raichu: {
		learnset: {
			babydolleyes: ["8T"],
			calmmind: ["8T"],
			chargebeam: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T", "8L37"],
			playrough: ["8T"],
			quickattack: ["8L5"],
			rest: ["8T"],
			rocksmash: ["8T"],
			spark: ["8L21"],
			swift: ["8T", "8L15"],
			thunder: ["8L47"],
			thunderbolt: ["8T", "8L29"],
			thunderpunch: ["8T"],
			thundershock: ["8L1"],
			thunderwave: ["8L9"],
			volttackle: ["8T"],
			wildcharge: ["8T"],
		},
	},
	clefairy: {
		learnset: {
			babydolleyes: ["8T", "8L9"],
			calmmind: ["8T", "8L21"],
			chargebeam: ["8T"],
			dazzlinggleam: ["8T"],
			doubleedge: ["8L47"],
			drainingkiss: ["8L15"],
			drainpunch: ["8T"],
			fairywind: ["8L5"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			magicalleaf: ["8T"],
			moonblast: ["8L37"],
			mysticalfire: ["8T"],
			playrough: ["8T"],
			psychic: ["8T", "8L29"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			stealthrock: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			triattack: ["8T"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	clefable: {
		learnset: {
			babydolleyes: ["8T", "8L9"],
			calmmind: ["8T", "8L21"],
			chargebeam: ["8T"],
			dazzlinggleam: ["8T"],
			doubleedge: ["8L47"],
			drainingkiss: ["8L15"],
			drainpunch: ["8T"],
			fairywind: ["8L5"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			magicalleaf: ["8T"],
			moonblast: ["8L37"],
			mysticalfire: ["8T"],
			playrough: ["8T"],
			psychic: ["8T", "8L29"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			stealthrock: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			triattack: ["8T"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	vulpix: {
		learnset: {
			babydolleyes: ["8T"],
			darkpulse: ["8T"],
			ember: ["8L1"],
			energyball: ["8T"],
			extrasensory: ["8L29"],
			fireblast: ["8L47"],
			flamethrower: ["8T", "8L37"],
			flamewheel: ["8L15"],
			hex: ["8L21"],
			irontail: ["8T"],
			mysticalfire: ["8T"],
			nastyplot: ["8L9"],
			ominouswind: ["8T"],
			quickattack: ["8L5"],
			rest: ["8T"],
			swift: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	vulpixalola: {
		learnset: {
			babydolleyes: ["8T"],
			blizzard: ["8L47"],
			darkpulse: ["8T"],
			dazzlinggleam: ["8T", "8L29"],
			drainingkiss: ["8L15"],
			energyball: ["8T"],
			icebeam: ["8T", "8L37"],
			icefang: ["8T", "8L21"],
			icywind: ["8T"],
			irontail: ["8T"],
			nastyplot: ["8L9"],
			powdersnow: ["8L1"],
			quickattack: ["8L5"],
			rest: ["8T"],
			swift: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	ninetales: {
		learnset: {
			babydolleyes: ["8T"],
			calmmind: ["8T"],
			darkpulse: ["8T"],
			ember: ["8L1"],
			energyball: ["8T"],
			extrasensory: ["8L29"],
			fireblast: ["8L47"],
			flamethrower: ["8T", "8L37"],
			flamewheel: ["8L15"],
			gigaimpact: ["8T"],
			hex: ["8L21"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			mysticalfire: ["8T"],
			nastyplot: ["8L9"],
			ominouswind: ["8T"],
			quickattack: ["8L5"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	ninetalesalola: {
		learnset: {
			babydolleyes: ["8T"],
			blizzard: ["8L47"],
			calmmind: ["8T"],
			darkpulse: ["8T"],
			dazzlinggleam: ["8T", "8L29"],
			drainingkiss: ["8L15"],
			energyball: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T", "8L37"],
			icefang: ["8T", "8L21"],
			icywind: ["8T"],
			irontail: ["8T"],
			nastyplot: ["8L9"],
			powdersnow: ["8L1"],
			quickattack: ["8L5"],
			rest: ["8T"],
			swift: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	zubat: {
		learnset: {
			aerialace: ["8T"],
			aircutter: ["8L18"],
			airslash: ["8L34"],
			bite: ["8L11"],
			crosspoison: ["8L25"],
			gust: ["8L1"],
			hypnosis: ["8L6"],
			leechlife: ["8T", "8L43"],
			ominouswind: ["8T"],
			rest: ["8T"],
			shadowball: ["8T"],
			sludgebomb: ["8T"],
			swift: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	golbat: {
		learnset: {
			aerialace: ["8T"],
			aircutter: ["8L18"],
			airslash: ["8L34"],
			bite: ["8L11"],
			crosspoison: ["8L25"],
			gigaimpact: ["8T"],
			gust: ["8L1"],
			hyperbeam: ["8T"],
			hypnosis: ["8L6"],
			leechlife: ["8T", "8L43"],
			ominouswind: ["8T"],
			rest: ["8T"],
			shadowball: ["8T"],
			sludgebomb: ["8T"],
			swift: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	paras: {
		learnset: {
			absorb: ["8L1"],
			aerialace: ["8T"],
			energyball: ["8T", "8L47"],
			falseswipe: ["8T"],
			leechlife: ["8T"],
			poisonpowder: ["8L9"],
			rest: ["8T"],
			rocksmash: ["8T"],
			slash: ["8L21"],
			sludgebomb: ["8T"],
			spore: ["8L29"],
			stunspore: ["8L5"],
			venoshock: ["8L15"],
			xscissor: ["8T", "8L37"],
		},
	},
	parasect: {
		learnset: {
			absorb: ["8L1"],
			aerialace: ["8T"],
			energyball: ["8T", "8L47"],
			falseswipe: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			leechlife: ["8T"],
			poisonpowder: ["8L9"],
			rest: ["8T"],
			rocksmash: ["8T"],
			slash: ["8L21"],
			sludgebomb: ["8T"],
			spore: ["8L29"],
			stunspore: ["8L5"],
			venoshock: ["8L15"],
			xscissor: ["8T", "8L37"],
		},
	},
	psyduck: {
		learnset: {
			aerialace: ["8T"],
			aquatail: ["8T", "8L34"],
			bubble: ["8L1"],
			calmmind: ["8T"],
			confusion: ["8L6"],
			hydropump: ["8L43"],
			hypnosis: ["8L18"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowclaw: ["8T"],
			swift: ["8T"],
			triattack: ["8T"],
			waterpulse: ["8T", "8L11"],
			zenheadbutt: ["8T", "8L25"],
		},
	},
	golduck: {
		learnset: {
			aerialace: ["8T"],
			aquatail: ["8T", "8L34"],
			bubble: ["8L1"],
			calmmind: ["8T"],
			confusion: ["8L6"],
			gigaimpact: ["8T"],
			hydropump: ["8L43"],
			hyperbeam: ["8T"],
			hypnosis: ["8L18"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowclaw: ["8T"],
			swift: ["8T"],
			triattack: ["8T"],
			waterpulse: ["8T", "8L11"],
			zenheadbutt: ["8T", "8L25"],
		},
	},
	growlithehisui: {
		learnset: {
			aerialace: ["8T"],
			bite: ["8L9"],
			crunch: ["8L29"],
			doubleedge: ["8L37"],
			ember: ["8L5"],
			firefang: ["8T", "8L15"],
			flamethrower: ["8T"],
			flareblitz: ["8L47"],
			irontail: ["8T"],
			outrage: ["8T"],
			playrough: ["8T"],
			rest: ["8T"],
			rockslide: ["8T", "8L21"],
			rocksmash: ["8T"],
			snarl: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			wildcharge: ["8T"],
		},
	},
	arcaninehisui: {
		learnset: {
			aerialace: ["8T"],
			bite: ["8L9"],
			bulldoze: ["8T"],
			crunch: ["8L29"],
			doubleedge: ["8L37"],
			ember: ["8L5"],
			firefang: ["8T", "8L15"],
			flamethrower: ["8T"],
			flareblitz: ["8L47"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			ironhead: ["8T"],
			irontail: ["8T"],
			outrage: ["8T"],
			playrough: ["8T"],
			ragingfury: ["8L29"],
			rest: ["8T"],
			rockslide: ["8T", "8L21"],
			rocksmash: ["8T"],
			snarl: ["8T"],
			stoneedge: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			thunderfang: ["8T"],
			wildcharge: ["8T"],
		},
	},
	abra: {
		learnset: {
			calmmind: ["8T"],
			chargebeam: ["8T"],
			dazzlinggleam: ["8T"],
			drainpunch: ["8T"],
			energyball: ["8T"],
			firepunch: ["8T"],
			icepunch: ["8T"],
			irontail: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			teleport: ["8L1"],
			thunderpunch: ["8T"],
			triattack: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	kadabra: {
		learnset: {
			calmmind: ["8T", "8L11"],
			chargebeam: ["8T"],
			confusion: ["8L0"],
			dazzlinggleam: ["8T"],
			drainpunch: ["8T"],
			energyball: ["8T"],
			firepunch: ["8T"],
			hypnosis: ["8L6"],
			icepunch: ["8T"],
			irontail: ["8T"],
			psychic: ["8T", "8L43"],
			psychocut: ["8T", "8L18"],
			recover: ["8L34"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			teleport: ["8L1"],
			thunderpunch: ["8T"],
			triattack: ["8T"],
			zenheadbutt: ["8T", "8L25"],
		},
	},
	alakazam: {
		learnset: {
			calmmind: ["8T", "8L11"],
			chargebeam: ["8T"],
			confusion: ["8L6"],
			dazzlinggleam: ["8T"],
			drainpunch: ["8T"],
			energyball: ["8T"],
			firepunch: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			hypnosis: ["8L6"],
			icepunch: ["8T"],
			irontail: ["8T"],
			psychic: ["8T", "8L43"],
			psychocut: ["8T", "8L18"],
			recover: ["8L34"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			teleport: ["8L1"],
			thunderpunch: ["8T"],
			triattack: ["8T"],
			zenheadbutt: ["8T", "8L25"],
		},
	},
	machop: {
		learnset: {
			bulkup: ["8T", "8L25"],
			bulldoze: ["8T"],
			bulletpunch: ["8L11"],
			closecombat: ["8L43"],
			doubleedge: ["8L34"],
			doublehit: ["8L18"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			focusenergy: ["8T"],
			icepunch: ["8T"],
			machpunch: ["8L22"],
			poisonjab: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T", "8L6"],
			tackle: ["8L1"],
			thunderpunch: ["8T"],
		},
	},
	machoke: {
		learnset: {
			bulkup: ["8T", "8L25"],
			bulldoze: ["8T"],
			bulletpunch: ["8L11"],
			closecombat: ["8L43"],
			doubleedge: ["8L34"],
			doublehit: ["8L18"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			focusenergy: ["8T"],
			icepunch: ["8T"],
			machpunch: ["8L22"],
			poisonjab: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T", "8L6"],
			tackle: ["8L1"],
			thunderpunch: ["8T"],
		},
	},
	machamp: {
		learnset: {
			bulkup: ["8T", "8L25"],
			bulldoze: ["8T"],
			bulletpunch: ["8L11"],
			closecombat: ["8L43"],
			doubleedge: ["8L34"],
			doublehit: ["8L18"],
			drainpunch: ["8T", "8L30"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			highhorsepower: ["8T"],
			hyperbeam: ["8T"],
			icepunch: ["8T"],
			machpunch: ["8L22"],
			poisonjab: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T", "8L6"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			thunderpunch: ["8T"],
		},
	},
	tentacool: {
		learnset: {
			acidarmor: ["8L34"],
			bubble: ["8L6"],
			dazzlinggleam: ["8T"],
			hex: ["8L18"],
			hydropump: ["8L43"],
			icebeam: ["8T"],
			icywind: ["8T"],
			poisonjab: ["8T", "8L25"],
			poisonsting: ["8L1"],
			rest: ["8T"],
			sludgebomb: ["8T"],
			waterpulse: ["8T", "8L11"],
		},
	},
	tentacruel: {
		learnset: {
			acidarmor: ["8L34"],
			bubble: ["8L6"],
			dazzlinggleam: ["8T"],
			gigaimpact: ["8T"],
			hex: ["8L18"],
			hydropump: ["8L43"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icywind: ["8T"],
			poisonjab: ["8T", "8L25"],
			poisonsting: ["8L1"],
			rest: ["8T"],
			sludgebomb: ["8T"],
			waterpulse: ["8T", "8L11"],
		},
	},
	geodude: {
		learnset: {
			bulldoze: ["8T", "8L26"],
			doubleedge: ["8L37"],
			earthpower: ["8T"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			irondefense: ["8L15"],
			mudslap: ["8L9"],
			rest: ["8T"],
			rockslide: ["8T", "8L21"],
			rocksmash: ["8T"],
			rollout: ["8L1"],
			selfdestruct: ["8L47"],
			stealthrock: ["8T", "8L29"],
			stoneedge: ["8T"],
			tackle: ["8L5"],
			thunderpunch: ["8T"],
		},
	},
	graveler: {
		learnset: {
			bulldoze: ["8T", "8L26"],
			doubleedge: ["8L37"],
			earthpower: ["8T"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			irondefense: ["8L15"],
			mudslap: ["8L9"],
			rest: ["8T"],
			rockslide: ["8T", "8L21"],
			rocksmash: ["8T"],
			rollout: ["8L1"],
			selfdestruct: ["8L47"],
			stealthrock: ["8T", "8L29"],
			stoneedge: ["8T"],
			tackle: ["8L5"],
			thunderpunch: ["8T"],
		},
	},
	golem: {
		learnset: {
			bulldoze: ["8T", "8L26"],
			doubleedge: ["8L37"],
			earthpower: ["8T"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irondefense: ["8L15"],
			ironhead: ["8T"],
			mudslap: ["8L9"],
			rest: ["8T"],
			rockslide: ["8T", "8L21"],
			rocksmash: ["8T"],
			rollout: ["8L1"],
			selfdestruct: ["8L47"],
			stealthrock: ["8T", "8L29"],
			stoneedge: ["8T", "8L57"],
			tackle: ["8L5"],
			thunderpunch: ["8T"],
		},
	},
	ponyta: {
		learnset: {
			doubleedge: ["8L37"],
			doublehit: ["8L9"],
			ember: ["8L5"],
			fireblast: ["8L29"],
			flamethrower: ["8T"],
			flamewheel: ["8L15"],
			flareblitz: ["8L47"],
			highhorsepower: ["8T"],
			hypnosis: ["8L21"],
			irontail: ["8T"],
			mysticalfire: ["8T"],
			rest: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			wildcharge: ["8T"],
		},
	},
	rapidash: {
		learnset: {
			doubleedge: ["8L37"],
			doublehit: ["8L9"],
			ember: ["8L5"],
			fireblast: ["8L29"],
			flamethrower: ["8T"],
			flamewheel: ["8L15"],
			flareblitz: ["8L47"],
			gigaimpact: ["8T"],
			highhorsepower: ["8T"],
			hyperbeam: ["8T"],
			hypnosis: ["8L21"],
			irontail: ["8T"],
			megahorn: ["8T"],
			mysticalfire: ["8T"],
			poisonjab: ["8T"],
			rest: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			wildcharge: ["8T"],
		},
	},
	magnemite: {
		learnset: {
			chargebeam: ["8T"],
			flashcannon: ["8T", "8L25"],
			rest: ["8T"],
			spark: ["8L18"],
			steelbeam: ["8T"],
			swift: ["8T"],
			tackle: ["8L6"],
			thunder: ["8L43"],
			thunderbolt: ["8T", "8L34"],
			thundershock: ["8L1"],
			thunderwave: ["8L11"],
			wildcharge: ["8T"],
		},
	},
	magneton: {
		learnset: {
			chargebeam: ["8T"],
			flashcannon: ["8T", "8L25"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			rest: ["8T"],
			spark: ["8L18"],
			steelbeam: ["8T"],
			swift: ["8T"],
			tackle: ["8L6"],
			thunder: ["8L43"],
			thunderbolt: ["8T", "8L34"],
			thundershock: ["8L1"],
			thunderwave: ["8L11"],
			triattack: ["8T", "8L25"],
			wildcharge: ["8T"],
		},
	},
	gastly: {
		learnset: {
			astonish: ["8L1"],
			darkpulse: ["8T", "8L34"],
			dazzlinggleam: ["8T"],
			energyball: ["8T"],
			firepunch: ["8T"],
			hex: ["8L11"],
			hypnosis: ["8L25"],
			icepunch: ["8T"],
			icywind: ["8T"],
			ominouswind: ["8T"],
			poisongas: ["8L6"],
			poisonjab: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			shadowball: ["8T", "8L43"],
			sludgebomb: ["8T"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			venoshock: ["8L18"],
		},
	},
	haunter: {
		learnset: {
			astonish: ["8L1"],
			darkpulse: ["8T", "8L34"],
			dazzlinggleam: ["8T"],
			energyball: ["8T"],
			firepunch: ["8T"],
			hex: ["8L11"],
			hypnosis: ["8L25"],
			icepunch: ["8T"],
			icywind: ["8T"],
			ominouswind: ["8T"],
			poisongas: ["8L6"],
			poisonjab: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			shadowball: ["8T", "8L43"],
			shadowclaw: ["8T"],
			sludgebomb: ["8T"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			venoshock: ["8L18"],
		},
	},
	gengar: {
		learnset: {
			astonish: ["8L1"],
			darkpulse: ["8T", "8L34"],
			dazzlinggleam: ["8T"],
			drainpunch: ["8T"],
			energyball: ["8T"],
			firepunch: ["8T"],
			gigaimpact: ["8T"],
			hex: ["8L11"],
			hyperbeam: ["8T"],
			hypnosis: ["8L25"],
			icepunch: ["8T"],
			icywind: ["8T"],
			ominouswind: ["8T"],
			poisongas: ["8L6"],
			poisonjab: ["8T"],
			powershift: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T", "8L43"],
			shadowclaw: ["8T"],
			sludgebomb: ["8T"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			venoshock: ["8L18"],
		},
	},
	onix: {
		learnset: {
			bulldoze: ["8T", "8L11"],
			earthpower: ["8T"],
			flashcannon: ["8T"],
			highhorsepower: ["8T", "8L34"],
			ironhead: ["8T"],
			irontail: ["8T", "8L43"],
			powershift: ["8T"],
			rest: ["8T"],
			rockslide: ["8T", "8L18"],
			rocksmash: ["8T"],
			rollout: ["8L1"],
			stealthrock: ["8T", "8L25"],
			stoneedge: ["8T"],
			tackle: ["8L6"],
		},
	},
	voltorbhisui: {
		learnset: {
			chargebeam: ["8T"],
			energyball: ["8T", "8L21"],
			iceball: ["8T"],
			magicalleaf: ["8T"],
			rest: ["8T"],
			selfdestruct: ["8L47"],
			spark: ["8L15"],
			swift: ["8T"],
			tackle: ["8L5"],
			thunder: ["8L37"],
			thunderbolt: ["8T", "8L29"],
			thundershock: ["8L1"],
			thunderwave: ["8L9"],
			wildcharge: ["8T"],
		},
	},
	electrodehisui: {
		learnset: {
			chargebeam: ["8T"],
			chloroblast: ["8L47"],
			energyball: ["8T", "8L21"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			iceball: ["8T"],
			magicalleaf: ["8T"],
			rest: ["8T"],
			selfdestruct: ["8L47"],
			spark: ["8L15"],
			swift: ["8T"],
			tackle: ["8L5"],
			thunder: ["8L37"],
			thunderbolt: ["8T", "8L29"],
			thundershock: ["8L1"],
			thunderwave: ["8L9"],
			wildcharge: ["8T"],
		},
	},
	lickitung: {
		learnset: {
			aquatail: ["8T"],
			bulldoze: ["8T", "8L11"],
			doubleedge: ["8L25"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T", "8L43"],
			hyperbeam: ["8T"],
			iceball: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			rest: ["8T", "8L6"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			rollout: ["8L34"],
			tackle: ["8L1"],
			thunderpunch: ["8T"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T", "8L18"],
		},
	},
	rhyhorn: {
		learnset: {
			aquatail: ["8T"],
			bulldoze: ["8T", "8L6"],
			doubleedge: ["8L43"],
			earthpower: ["8T"],
			firefang: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T", "8L52"],
			highhorsepower: ["8T", "8L34"],
			icebeam: ["8T"],
			icefang: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			megahorn: ["8T"],
			poisonjab: ["8T"],
			rest: ["8T"],
			rockslide: ["8T", "8L25"],
			rocksmash: ["8T", "8L11"],
			stealthrock: ["8T", "8L18"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			thunderfang: ["8T"],
		},
	},
	rhydon: {
		learnset: {
			aquatail: ["8T"],
			bulldoze: ["8T", "8L6"],
			doubleedge: ["8L43"],
			earthpower: ["8T"],
			firefang: ["8T"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T", "8L52"],
			highhorsepower: ["8T", "8L34"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icefang: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			megahorn: ["8T"],
			outrage: ["8T"],
			poisonjab: ["8T"],
			rest: ["8T"],
			rockslide: ["8T", "8L25"],
			rocksmash: ["8T", "8L11"],
			shadowclaw: ["8T"],
			stealthrock: ["8T", "8L18"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			thunderfang: ["8T"],
			thunderpunch: ["8T"],
		},
	},
	chansey: {
		learnset: {
			babydolleyes: ["8T", "8L11"],
			bulldoze: ["8T"],
			calmmind: ["8T", "8L25"],
			chargebeam: ["8T"],
			dazzlinggleam: ["8T"],
			doubleedge: ["8L43"],
			drainingkiss: ["8L18"],
			drainpunch: ["8T"],
			fairywind: ["8L6"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			softboiled: ["8L34"],
			stealthrock: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			triattack: ["8T"],
			waterpulse: ["8T"],
			wildcharge: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	tangela: {
		learnset: {
			absorb: ["8L1"],
			acidspray: ["8L15"],
			ancientpower: ["8L34"],
			doublehit: ["8L18"],
			energyball: ["8T", "8L25"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			poisonpowder: ["8L11"],
			rest: ["8T"],
			rocksmash: ["8T"],
			sleeppowder: ["8L43"],
			sludgebomb: ["8T"],
			stunspore: ["8L6"],
		},
	},
	mrmime: {
		learnset: {
			aerialace: ["8T"],
			calmmind: ["8T", "8L43"],
			chargebeam: ["8T"],
			confusion: ["8L1"],
			dazzlinggleam: ["8T", "8L46"],
			drainpunch: ["8T"],
			energyball: ["8T"],
			firepunch: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			hypnosis: ["8L6"],
			icepunch: ["8T"],
			icywind: ["8T"],
			irondefense: ["8L11"],
			magicalleaf: ["8T"],
			mimic: ["8L25"],
			mysticalfire: ["8T"],
			powershift: ["8T"],
			psychic: ["8T", "8L34"],
			rest: ["8T"],
			shadowball: ["8T"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			zenheadbutt: ["8T", "8L18"],
		},
	},
	scyther: {
		learnset: {
			aerialace: ["8T", "8L11"],
			airslash: ["8L18"],
			calmmind: ["8T"],
			closecombat: ["8L43"],
			doublehit: ["8L14"],
			falseswipe: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			ominouswind: ["8T"],
			psychocut: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T"],
			silverwind: ["8L6"],
			swift: ["8T"],
			swordsdance: ["8L25"],
			xscissor: ["8T", "8L34"],
		},
	},
	electabuzz: {
		learnset: {
			chargebeam: ["8T"],
			firepunch: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icepunch: ["8T"],
			irontail: ["8T"],
			psychic: ["8T"],
			quickattack: ["8L6"],
			rest: ["8T"],
			rocksmash: ["8T"],
			spark: ["8L11"],
			swift: ["8T"],
			thunder: ["8L43"],
			thunderbolt: ["8T", "8L34"],
			thunderpunch: ["8T", "8L25"],
			thundershock: ["8L1"],
			thunderwave: ["8L18"],
			wildcharge: ["8T"],
		},
	},
	magmar: {
		learnset: {
			ember: ["8L1"],
			fireblast: ["8L43"],
			firepunch: ["8T", "8L25"],
			flamethrower: ["8T", "8L34"],
			flamewheel: ["8L11"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			poisongas: ["8L18"],
			psychic: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			tackle: ["8L6"],
			thunderpunch: ["8T"],
		},
	},
	magikarp: {
		learnset: {
			splash: ["8L1"],
		},
	},
	gyarados: {
		learnset: {
			aquatail: ["8T", "8L29"],
			bite: ["8L9"],
			bulldoze: ["8T"],
			crunch: ["8L21"],
			darkpulse: ["8T"],
			flamethrower: ["8T"],
			focusenergy: ["8T", "8L15"],
			gigaimpact: ["8T"],
			hurricane: ["8L37"],
			hydropump: ["8L47"],
			hyperbeam: ["8T", "8L57"],
			icebeam: ["8T"],
			icefang: ["8T"],
			icywind: ["8T"],
			ironhead: ["8T"],
			irontail: ["8T"],
			outrage: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			splash: ["8L1"],
			stoneedge: ["8T"],
			thunderbolt: ["8T"],
			twister: ["8L5"],
			waterpulse: ["8T", "8L0"],
		},
	},
	eevee: {
		learnset: {
			babydolleyes: ["8T", "8L18"],
			calmmind: ["8T", "8L34"],
			doubleedge: ["8L43"],
			focusenergy: ["8T"],
			irontail: ["8T"],
			mimic: ["8L25"],
			quickattack: ["8L6"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T", "8L11"],
			tackle: ["8L1"],
		},
	},
	vaporeon: {
		learnset: {
			aquatail: ["8T", "8L25"],
			babydolleyes: ["8T", "8L18"],
			bubble: ["8L0"],
			calmmind: ["8T", "8L34"],
			doubleedge: ["8L43"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			mimic: ["8L25"],
			quickattack: ["8L6"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			swift: ["8T", "8L11"],
			tackle: ["8L1"],
			waterpulse: ["8T"],
		},
	},
	jolteon: {
		learnset: {
			babydolleyes: ["8T", "8L18"],
			calmmind: ["8T", "8L34"],
			chargebeam: ["8T"],
			doubleedge: ["8L43"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			mimic: ["8L25"],
			quickattack: ["8L6"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			swift: ["8T", "8L11"],
			tackle: ["8L1"],
			thunderbolt: ["8T", "8L25"],
			thunderfang: ["8T"],
			thundershock: ["8L0"],
			wildcharge: ["8T"],
		},
	},
	flareon: {
		learnset: {
			babydolleyes: ["8T", "8L18"],
			calmmind: ["8T", "8L34"],
			doubleedge: ["8L43"],
			ember: ["8L0"],
			firefang: ["8T"],
			flamethrower: ["8T", "8L25"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			mimic: ["8L25"],
			mysticalfire: ["8T"],
			powershift: ["8T"],
			quickattack: ["8L6"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			swift: ["8T", "8L11"],
			tackle: ["8L1"],
		},
	},
	porygon: {
		learnset: {
			aerialace: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T", "8L47"],
			icebeam: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			psychic: ["8T"],
			recover: ["8L37"],
			rest: ["8T"],
			shadowball: ["8T"],
			spark: ["8L15"],
			swift: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T", "8L29"],
			thundershock: ["8L5"],
			thunderwave: ["8L9"],
			triattack: ["8T", "8L21"],
			zenheadbutt: ["8T"],
		},
	},
	snorlax: {
		learnset: {
			bite: ["8L21"],
			bulldoze: ["8T", "8L15"],
			crunch: ["8L35"],
			doubleedge: ["8L46"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T", "8L57"],
			highhorsepower: ["8T", "8L37"],
			hyperbeam: ["8T"],
			iceball: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			ironhead: ["8T"],
			outrage: ["8T"],
			psychic: ["8T"],
			rest: ["8T", "8L9"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			rollout: ["8L1"],
			shadowball: ["8T"],
			tackle: ["8L5"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			waterpulse: ["8T"],
			wildcharge: ["8T"],
			zenheadbutt: ["8T", "8L29"],
		},
	},
	cyndaquil: {
		learnset: {
			aerialace: ["8T"],
			ember: ["8L6"],
			flamethrower: ["8T", "8L34"],
			flamewheel: ["8L18"],
			irontail: ["8T"],
			overheat: ["8L43"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rollout: ["8L11"],
			swift: ["8T", "8L25"],
			wildcharge: ["8T"],
		},
	},
	quilava: {
		learnset: {
			aerialace: ["8T"],
			ember: ["8L6"],
			flamethrower: ["8T", "8L34"],
			flamewheel: ["8L18"],
			irontail: ["8T"],
			overheat: ["8L43"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T"],
			rollout: ["8L11"],
			swift: ["8T", "8L25"],
			wildcharge: ["8T"],
		},
	},
	typhlosionhisui: {
		learnset: {
			aerialace: ["8T"],
			bulldoze: ["8T"],
			calmmind: ["8T"],
			drainpunch: ["8T"],
			ember: ["8L6"],
			firepunch: ["8T"],
			flamethrower: ["8T", "8L34"],
			flamewheel: ["8L18"],
			gigaimpact: ["8T"],
			hex: ["8L0"],
			hyperbeam: ["8T"],
			infernalparade: ["8L40"],
			irontail: ["8T"],
			mysticalfire: ["8T"],
			ominouswind: ["8T"],
			overheat: ["8L43"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			rollout: ["8L11"],
			shadowball: ["8T", "8L43"],
			shadowclaw: ["8T"],
			swift: ["8T", "8L25"],
			thunderpunch: ["8T"],
			wildcharge: ["8T"],
		},
	},
	crobat: {
		learnset: {
			aerialace: ["8T"],
			aircutter: ["8L18"],
			airslash: ["8L34"],
			bite: ["8L11"],
			crosspoison: ["8L25"],
			darkpulse: ["8T"],
			gigaimpact: ["8T"],
			gust: ["8L1"],
			hyperbeam: ["8T"],
			hypnosis: ["8L6"],
			leechlife: ["8T", "8L43"],
			ominouswind: ["8T"],
			rest: ["8T"],
			shadowball: ["8T"],
			sludgebomb: ["8T"],
			swift: ["8T"],
			xscissor: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	pichu: {
		learnset: {
			babydolleyes: ["8T"],
			chargebeam: ["8T"],
			irontail: ["8T", "8L37"],
			playrough: ["8T"],
			quickattack: ["8L5"],
			rest: ["8T"],
			spark: ["8L21"],
			swift: ["8T", "8L15"],
			thunder: ["8L47"],
			thunderbolt: ["8T", "8L29"],
			thunderpunch: ["8T"],
			thundershock: ["8L1"],
			thunderwave: ["8L9"],
			volttackle: ["8T"],
			wildcharge: ["8T"],
		},
	},
	cleffa: {
		learnset: {
			babydolleyes: ["8T", "8L9"],
			calmmind: ["8T", "8L21"],
			doubleedge: ["8L47"],
			drainingkiss: ["8L15"],
			fairywind: ["8L5"],
			flamethrower: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			magicalleaf: ["8T"],
			moonblast: ["8L37"],
			playrough: ["8T"],
			psychic: ["8T", "8L29"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	togepi: {
		learnset: {
			babydolleyes: ["8T", "8L25"],
			calmmind: ["8T", "8L18"],
			dazzlinggleam: ["8T"],
			drainingkiss: ["8L11"],
			extrasensory: ["8L34"],
			fairywind: ["8L6"],
			flamethrower: ["8T"],
			moonblast: ["8L43"],
			mysticalfire: ["8T"],
			playrough: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			triattack: ["8T"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	togetic: {
		learnset: {
			aerialace: ["8T"],
			aircutter: ["8L0"],
			airslash: ["8L25"],
			babydolleyes: ["8T", "8L25"],
			calmmind: ["8T", "8L18"],
			dazzlinggleam: ["8T"],
			drainingkiss: ["8L11"],
			drainpunch: ["8T"],
			extrasensory: ["8L34"],
			fairywind: ["8L6"],
			flamethrower: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			magicalleaf: ["8T"],
			moonblast: ["8L43"],
			mysticalfire: ["8T"],
			ominouswind: ["8T"],
			playrough: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			triattack: ["8T"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	sudowoodo: {
		learnset: {
			bulldoze: ["8T"],
			calmmind: ["8T"],
			doubleedge: ["8L37"],
			earthpower: ["8T"],
			firepunch: ["8T"],
			headsmash: ["8L47"],
			icepunch: ["8T"],
			irondefense: ["8L21"],
			mimic: ["8L29"],
			rest: ["8T"],
			rockslide: ["8T", "8L15"],
			rocksmash: ["8T"],
			rollout: ["8L1"],
			stealthrock: ["8T", "8L9"],
			stoneedge: ["8T"],
			tackle: ["8L5"],
			thunderpunch: ["8T"],
			woodhammer: ["8L57"],
		},
	},
	aipom: {
		learnset: {
			aerialace: ["8T"],
			doubleedge: ["8L43"],
			doublehit: ["8L25"],
			firepunch: ["8T"],
			icepunch: ["8T"],
			irontail: ["8T", "8L34"],
			mudbomb: ["8L18"],
			nastyplot: ["8L6"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			shadowclaw: ["8T"],
			swift: ["8T", "8L11"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			waterpulse: ["8T"],
		},
	},
	yanma: {
		learnset: {
			airslash: ["8L25"],
			ancientpower: ["8L34"],
			bugbuzz: ["8L43"],
			gust: ["8L6"],
			hypnosis: ["8L18"],
			leechlife: ["8T"],
			ominouswind: ["8T"],
			psychic: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			shadowball: ["8T"],
			silverwind: ["8L11"],
			swift: ["8T"],
		},
	},
	espeon: {
		learnset: {
			babydolleyes: ["8T", "8L18"],
			calmmind: ["8T", "8L34"],
			confusion: ["8L0"],
			dazzlinggleam: ["8T"],
			doubleedge: ["8L43"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			mimic: ["8L25"],
			psychic: ["8T", "8L25"],
			quickattack: ["8L6"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			swift: ["8T", "8L11"],
			tackle: ["8L1"],
			zenheadbutt: ["8T"],
		},
	},
	umbreon: {
		learnset: {
			babydolleyes: ["8T", "8L18"],
			calmmind: ["8T", "8L34"],
			darkpulse: ["8T", "8L25"],
			doubleedge: ["8L43"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			mimic: ["8L25"],
			powershift: ["8T"],
			psychic: ["8T"],
			quickattack: ["8L6"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			snarl: ["8T", "8L0"],
			swift: ["8T", "8L11"],
			tackle: ["8L1"],
		},
	},
	murkrow: {
		learnset: {
			aerialace: ["8T", "8L18"],
			airslash: ["8L30"],
			calmmind: ["8T"],
			darkpulse: ["8T", "8L43"],
			gust: ["8L1"],
			icywind: ["8T"],
			nastyplot: ["8L34"],
			nightslash: ["8L25"],
			ominouswind: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			roost: ["8L11"],
			shadowball: ["8T"],
			snarl: ["8T", "8L6"],
			swift: ["8T"],
		},
	},
	misdreavus: {
		learnset: {
			aerialace: ["8T"],
			calmmind: ["8T"],
			chargebeam: ["8T"],
			confusion: ["8L6"],
			darkpulse: ["8T"],
			dazzlinggleam: ["8T"],
			extrasensory: ["8L25"],
			hex: ["8L18"],
			hypnosis: ["8L11"],
			icywind: ["8T"],
			ominouswind: ["8T"],
			powergem: ["8L34"],
			psychic: ["8T"],
			rest: ["8T"],
			shadowball: ["8T", "8L43"],
			shadowsneak: ["8L1"],
			swift: ["8T"],
			thunderbolt: ["8T"],
		},
	},
	unown: {
		learnset: {
			hiddenpower: ["8L1"],
		},
	},
	gligar: {
		learnset: {
			aerialace: ["8T", "8L11"],
			aquatail: ["8T"],
			bulldoze: ["8T"],
			darkpulse: ["8T"],
			earthpower: ["8T"],
			falseswipe: ["8T"],
			irontail: ["8T"],
			mudbomb: ["8L18"],
			poisonjab: ["8T", "8L34"],
			poisonsting: ["8L1"],
			quickattack: ["8L6"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			slash: ["8L25"],
			sludgebomb: ["8T"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			swift: ["8T"],
			xscissor: ["8T", "8L43"],
		},
	},
	steelix: {
		learnset: {
			aquatail: ["8T"],
			bulldoze: ["8T", "8L11"],
			darkpulse: ["8T"],
			earthpower: ["8T"],
			firefang: ["8T"],
			flashcannon: ["8T"],
			gigaimpact: ["8T"],
			highhorsepower: ["8T", "8L34"],
			hyperbeam: ["8T"],
			iceball: ["8T"],
			icefang: ["8T"],
			ironhead: ["8T"],
			irontail: ["8T", "8L43"],
			powershift: ["8T"],
			rest: ["8T"],
			rockslide: ["8T", "8L18"],
			rocksmash: ["8T"],
			rollout: ["8L1"],
			stealthrock: ["8T", "8L25"],
			steelbeam: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L6"],
			thunderfang: ["8T"],
		},
	},
	qwilfishhisui: {
		learnset: {
			aquatail: ["8T", "8L37"],
			barbbarrage: ["8L15"],
			darkpulse: ["8T", "8L26"],
			doubleedge: ["8L47"],
			iceball: ["8T"],
			icebeam: ["8T"],
			icywind: ["8T"],
			pinmissile: ["8L9"],
			poisonjab: ["8T", "8L29"],
			poisonsting: ["8L1"],
			rest: ["8T"],
			selfdestruct: ["8L57"],
			shadowball: ["8T"],
			sludgebomb: ["8T"],
			spikes: ["8T", "8L5"],
			swift: ["8T"],
			waterpulse: ["8T", "8L21"],
		},
	},
	scizor: {
		learnset: {
			aerialace: ["8T", "8L11"],
			airslash: ["8L18"],
			bulletpunch: ["8L29"],
			calmmind: ["8T"],
			closecombat: ["8L43"],
			doublehit: ["8L14"],
			falseswipe: ["8T"],
			flashcannon: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			ironhead: ["8T", "8L34"],
			ominouswind: ["8T"],
			psychocut: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T"],
			silverwind: ["8L6"],
			steelbeam: ["8T"],
			swift: ["8T"],
			swordsdance: ["8L25"],
			xscissor: ["8T", "8L34"],
		},
	},
	heracross: {
		learnset: {
			aerialace: ["8T", "8L15"],
			bulkup: ["8T"],
			bulldoze: ["8T"],
			calmmind: ["8T"],
			closecombat: ["8L47"],
			doubleedge: ["8L37"],
			falseswipe: ["8T"],
			gigaimpact: ["8T"],
			highhorsepower: ["8T"],
			hyperbeam: ["8T"],
			megahorn: ["8T", "8L57"],
			outrage: ["8T"],
			pinmissile: ["8L9"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T", "8L5"],
			shadowclaw: ["8T"],
			slash: ["8L21"],
			spikes: ["8T"],
			stoneedge: ["8T"],
			swordsdance: ["8L29"],
			tackle: ["8L1"],
		},
	},
	sneasel: {
		learnset: {
			aerialace: ["8T"],
			blizzard: ["8L43"],
			calmmind: ["8T"],
			darkpulse: ["8T"],
			falseswipe: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			iceshard: ["8L6"],
			icywind: ["8T"],
			irontail: ["8T"],
			poisonjab: ["8T", "8L25"],
			psychocut: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			shadowclaw: ["8T"],
			slash: ["8L18"],
			snarl: ["8T"],
			swift: ["8T", "8L11"],
			swordsdance: ["8L34"],
			xscissor: ["8T"],
		},
	},
	sneaselhisui: {
		learnset: {
			aerialace: ["8T"],
			bulkup: ["8T"],
			calmmind: ["8T"],
			closecombat: ["8L43"],
			drainpunch: ["8T"],
			falseswipe: ["8T"],
			focusenergy: ["8T"],
			irontail: ["8T"],
			poisonjab: ["8T", "8L25"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T", "8L6"],
			shadowball: ["8T"],
			shadowclaw: ["8T"],
			slash: ["8L18"],
			snarl: ["8T"],
			swift: ["8T", "8L11"],
			swordsdance: ["8L34"],
			xscissor: ["8T"],
		},
	},
	teddiursa: {
		learnset: {
			aerialace: ["8T"],
			babydolleyes: ["8T", "8L6"],
			bulkup: ["8T"],
			bulldoze: ["8T", "8L11"],
			doubleedge: ["8L43"],
			firepunch: ["8T"],
			focusenergy: ["8T"],
			highhorsepower: ["8T", "8L34"],
			icepunch: ["8T"],
			playrough: ["8T", "8L25"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowclaw: ["8T"],
			slash: ["8L18"],
			swift: ["8T"],
			tackle: ["8L1"],
			thunderpunch: ["8T"],
		},
	},
	ursaring: {
		learnset: {
			aerialace: ["8T"],
			babydolleyes: ["8T", "8L6"],
			bulkup: ["8T"],
			bulldoze: ["8T", "8L11"],
			doubleedge: ["8L43"],
			firepunch: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			highhorsepower: ["8T", "8L34"],
			hyperbeam: ["8T"],
			icepunch: ["8T"],
			playrough: ["8T", "8L25"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowclaw: ["8T"],
			slash: ["8L18"],
			stoneedge: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			thunderpunch: ["8T"],
		},
	},
	swinub: {
		learnset: {
			ancientpower: ["8L34"],
			babydolleyes: ["8T"],
			blizzard: ["8L43"],
			bulldoze: ["8T", "8L11"],
			doubleedge: ["8L52"],
			earthpower: ["8T"],
			highhorsepower: ["8T", "8L25"],
			icebeam: ["8T"],
			iceshard: ["8L6"],
			iciclecrash: ["8L18"],
			icywind: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			stealthrock: ["8T"],
			tackle: ["8L1"],
		},
	},
	piloswine: {
		learnset: {
			ancientpower: ["8L34"],
			babydolleyes: ["8T"],
			blizzard: ["8L43"],
			bulldoze: ["8T", "8L11"],
			doubleedge: ["8L52"],
			earthpower: ["8T"],
			gigaimpact: ["8T"],
			highhorsepower: ["8T", "8L25"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icefang: ["8T"],
			iceshard: ["8L6"],
			iciclecrash: ["8L18"],
			icywind: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
		},
	},
	remoraid: {
		learnset: {
			acidspray: ["8L6"],
			bubble: ["8L1"],
			chargebeam: ["8T", "8L11"],
			focusenergy: ["8T"],
			hydropump: ["8L34"],
			hyperbeam: ["8T", "8L43"],
			icebeam: ["8T", "8L25"],
			icywind: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			swift: ["8T"],
			waterpulse: ["8T", "8L18"],
		},
	},
	octillery: {
		learnset: {
			acidspray: ["8L6"],
			bubble: ["8L1"],
			chargebeam: ["8T", "8L11"],
			energyball: ["8T"],
			flamethrower: ["8T"],
			flashcannon: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hydropump: ["8L34"],
			hyperbeam: ["8T", "8L43"],
			icebeam: ["8T", "8L25"],
			icywind: ["8T"],
			octazooka: ["8L0"],
			psychic: ["8T"],
			rest: ["8T"],
			sludgebomb: ["8T"],
			swift: ["8T"],
			waterpulse: ["8T", "8L18"],
		},
	},
	mantine: {
		learnset: {
			aerialace: ["8T", "8L9"],
			airslash: ["8L21"],
			aquatail: ["8T"],
			bubble: ["8L5"],
			bulldoze: ["8T"],
			doubleedge: ["8L47"],
			gigaimpact: ["8T"],
			hydropump: ["8L37"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icywind: ["8T"],
			ironhead: ["8T"],
			powershift: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			roost: ["8L29"],
			swift: ["8T"],
			tackle: ["8L1"],
			waterpulse: ["8T", "8L15"],
		},
	},
	porygon2: {
		learnset: {
			aerialace: ["8T"],
			chargebeam: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T", "8L47"],
			icebeam: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			psychic: ["8T"],
			recover: ["8L37"],
			rest: ["8T"],
			shadowball: ["8T"],
			spark: ["8L15"],
			swift: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T", "8L29"],
			thundershock: ["8L5"],
			thunderwave: ["8L9"],
			triattack: ["8T", "8L21"],
			zenheadbutt: ["8T"],
		},
	},
	stantler: {
		learnset: {
			bulldoze: ["8T"],
			calmmind: ["8T", "8L15"],
			chargebeam: ["8T"],
			confusion: ["8L5"],
			doubleedge: ["8L47"],
			energyball: ["8T"],
			extrasensory: ["8L29"],
			gigaimpact: ["8T"],
			hypnosis: ["8L9"],
			irontail: ["8T"],
			megahorn: ["8T"],
			psychic: ["8T"],
			psyshieldbash: ["8L21"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			wildcharge: ["8T"],
			zenheadbutt: ["8T", "8L37"],
		},
	},
	elekid: {
		learnset: {
			chargebeam: ["8T"],
			firepunch: ["8T"],
			icepunch: ["8T"],
			psychic: ["8T"],
			quickattack: ["8L6"],
			rest: ["8T"],
			rocksmash: ["8T"],
			spark: ["8L11"],
			swift: ["8T"],
			thunder: ["8L43"],
			thunderbolt: ["8T", "8L34"],
			thunderpunch: ["8T", "8L25"],
			thundershock: ["8L1"],
			thunderwave: ["8L18"],
			wildcharge: ["8T"],
		},
	},
	magby: {
		learnset: {
			ember: ["8L1"],
			fireblast: ["8L43"],
			firepunch: ["8T", "8L25"],
			flamethrower: ["8T", "8L34"],
			flamewheel: ["8L11"],
			focusenergy: ["8T"],
			irontail: ["8T"],
			poisongas: ["8L18"],
			psychic: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			tackle: ["8L6"],
			thunderpunch: ["8T"],
		},
	},
	blissey: {
		learnset: {
			babydolleyes: ["8T", "8L11"],
			bulldoze: ["8T"],
			calmmind: ["8T", "8L25"],
			chargebeam: ["8T"],
			dazzlinggleam: ["8T"],
			doubleedge: ["8L43"],
			drainingkiss: ["8L18"],
			drainpunch: ["8T"],
			fairywind: ["8L6"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			powershift: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			softboiled: ["8L34"],
			stealthrock: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			triattack: ["8T"],
			waterpulse: ["8T"],
			wildcharge: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	wurmple: {
		learnset: {
			poisonsting: ["8L1"],
			tackle: ["8L6"],
		},
	},
	silcoon: {
		learnset: {
			irondefense: ["8L0"],
			poisonsting: ["8L1"],
			tackle: ["8L6"],
		},
	},
	beautifly: {
		learnset: {
			aerialace: ["8T"],
			aircutter: ["8L0"],
			airslash: ["8L34"],
			bugbuzz: ["8L43"],
			energyball: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irondefense: ["8L6"],
			leechlife: ["8T"],
			ominouswind: ["8T"],
			poisonsting: ["8L1"],
			psychic: ["8T"],
			rest: ["8T"],
			shadowball: ["8T"],
			silverwind: ["8L18"],
			stunspore: ["8L11"],
			swift: ["8T"],
			tackle: ["8L6"],
			venoshock: ["8L25"],
		},
	},
	cascoon: {
		learnset: {
			irondefense: ["8L0"],
			poisonsting: ["8L1"],
			tackle: ["8L6"],
		},
	},
	dustox: {
		learnset: {
			aerialace: ["8T"],
			bugbuzz: ["8L43"],
			confusion: ["8L0"],
			energyball: ["8T"],
			extrasensory: ["8L34"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irondefense: ["8L6"],
			ominouswind: ["8T"],
			poisonpowder: ["8L11"],
			poisonsting: ["8L1"],
			psychic: ["8T"],
			rest: ["8T"],
			shadowball: ["8T"],
			silverwind: ["8L18"],
			sludgebomb: ["8T"],
			swift: ["8T"],
			tackle: ["8L6"],
			venoshock: ["8L25"],
		},
	},
	ralts: {
		learnset: {
			calmmind: ["8T", "8L25"],
			chargebeam: ["8T"],
			confusion: ["8L1"],
			dazzlinggleam: ["8T"],
			drainingkiss: ["8L11"],
			firepunch: ["8T"],
			hypnosis: ["8L18"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			magicalleaf: ["8T"],
			psychic: ["8T", "8L34"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			teleport: ["8L6"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	kirlia: {
		learnset: {
			calmmind: ["8T", "8L25"],
			chargebeam: ["8T"],
			confusion: ["8L1"],
			dazzlinggleam: ["8T"],
			drainingkiss: ["8L11"],
			firepunch: ["8T"],
			hypnosis: ["8L18"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			magicalleaf: ["8T"],
			psychic: ["8T", "8L34"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			teleport: ["8L6"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	gardevoir: {
		learnset: {
			aurasphere: ["8L40"],
			calmmind: ["8T", "8L25"],
			chargebeam: ["8T"],
			confusion: ["8L1"],
			dazzlinggleam: ["8T", "8L0"],
			drainingkiss: ["8L11"],
			energyball: ["8T"],
			firepunch: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			hypnosis: ["8L18"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			magicalleaf: ["8T"],
			moonblast: ["8L43"],
			mysticalfire: ["8T"],
			psychic: ["8T", "8L34"],
			recover: ["8L52"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			teleport: ["8L6"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	nosepass: {
		learnset: {
			bulldoze: ["8T"],
			earthpower: ["8T", "8L43"],
			firepunch: ["8T"],
			flashcannon: ["8T"],
			icepunch: ["8T"],
			irondefense: ["8L18"],
			powergem: ["8L34"],
			powershift: ["8T"],
			rest: ["8T"],
			rockslide: ["8T", "8L25"],
			rocksmash: ["8T"],
			spark: ["8L11"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			thunderwave: ["8L6"],
		},
	},
	roselia: {
		learnset: {
			absorb: ["8L6"],
			dazzlinggleam: ["8T"],
			energyball: ["8T", "8L43"],
			magicalleaf: ["8T"],
			petaldance: ["8L52"],
			poisonjab: ["8T", "8L34"],
			poisonpowder: ["8L11"],
			poisonsting: ["8L1"],
			rest: ["8T"],
			shadowball: ["8T"],
			sludgebomb: ["8T"],
			spikes: ["8T"],
			stunspore: ["8L18"],
			swift: ["8T"],
			venoshock: ["8L25"],
		},
	},
	barboach: {
		learnset: {
			aquatail: ["8T", "8L34"],
			bulldoze: ["8T"],
			earthpower: ["8T", "8L43"],
			icebeam: ["8T"],
			icywind: ["8T"],
			mudbomb: ["8L11"],
			mudslap: ["8L1"],
			rest: ["8T", "8L18"],
			waterpulse: ["8T", "8L6"],
			zenheadbutt: ["8T", "8L25"],
		},
	},
	whiscash: {
		learnset: {
			aerialace: ["8T"],
			aquatail: ["8T", "8L34"],
			bulldoze: ["8T"],
			earthpower: ["8T", "8L43"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icywind: ["8T"],
			mudbomb: ["8L11"],
			mudslap: ["8L1"],
			rest: ["8T", "8L18"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			stoneedge: ["8T"],
			waterpulse: ["8T", "8L6"],
			zenheadbutt: ["8T", "8L25"],
		},
	},
	duskull: {
		learnset: {
			absorb: ["8L1"],
			calmmind: ["8T"],
			chargebeam: ["8T"],
			darkpulse: ["8T", "8L25"],
			hex: ["8L11"],
			icebeam: ["8T"],
			icywind: ["8T"],
			leechlife: ["8T", "8L18"],
			ominouswind: ["8T"],
			psychic: ["8T", "8L43"],
			rest: ["8T"],
			shadowball: ["8T", "8L34"],
			shadowsneak: ["8L6"],
		},
	},
	dusclops: {
		learnset: {
			absorb: ["8L1"],
			bulldoze: ["8T"],
			calmmind: ["8T"],
			chargebeam: ["8T"],
			darkpulse: ["8T", "8L25"],
			firepunch: ["8T"],
			gigaimpact: ["8T"],
			hex: ["8L11"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			leechlife: ["8T", "8L18"],
			ominouswind: ["8T"],
			powershift: ["8T"],
			psychic: ["8T", "8L43"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T", "8L34"],
			shadowsneak: ["8L6"],
			thunderpunch: ["8T"],
		},
	},
	chimecho: {
		learnset: {
			calmmind: ["8T"],
			chargebeam: ["8T"],
			confusion: ["8L6"],
			dazzlinggleam: ["8T"],
			doubleedge: ["8L43"],
			energyball: ["8T"],
			extrasensory: ["8L25"],
			hypnosis: ["8L18"],
			icywind: ["8T"],
			ominouswind: ["8T", "8L11"],
			psychic: ["8T"],
			recover: ["8L34"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			zenheadbutt: ["8T"],
		},
	},
	snorunt: {
		learnset: {
			bite: ["8L11"],
			blizzard: ["8L43"],
			crunch: ["8L25"],
			icebeam: ["8T"],
			icefang: ["8T", "8L18"],
			iceshard: ["8L6"],
			iciclecrash: ["8L34"],
			icywind: ["8T"],
			powdersnow: ["8L1"],
			rest: ["8T"],
			shadowball: ["8T"],
			spikes: ["8T"],
			waterpulse: ["8T"],
		},
	},
	glalie: {
		learnset: {
			bite: ["8L11"],
			blizzard: ["8L43"],
			bulldoze: ["8T"],
			crunch: ["8L25"],
			darkpulse: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			iceball: ["8T", "8L1"],
			icebeam: ["8T"],
			icefang: ["8T", "8L18"],
			iceshard: ["8L6"],
			iciclecrash: ["8L34"],
			icywind: ["8T"],
			ironhead: ["8T"],
			powdersnow: ["8L1"],
			rest: ["8T"],
			shadowball: ["8T"],
			spikes: ["8T"],
			waterpulse: ["8T"],
		},
	},
	spheal: {
		learnset: {
			aquatail: ["8T"],
			babydolleyes: ["8T"],
			blizzard: ["8L43"],
			bulldoze: ["8T"],
			iceball: ["8T"],
			icebeam: ["8T", "8L34"],
			icywind: ["8T"],
			irontail: ["8T"],
			liquidation: ["8L25"],
			powdersnow: ["8L6"],
			rest: ["8T", "8L18"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			rollout: ["8L1"],
			waterpulse: ["8T", "8L11"],
		},
	},
	sealeo: {
		learnset: {
			aquatail: ["8T"],
			babydolleyes: ["8T"],
			blizzard: ["8L43"],
			bulldoze: ["8T"],
			iceball: ["8T"],
			icebeam: ["8T", "8L34"],
			icywind: ["8T"],
			irontail: ["8T"],
			liquidation: ["8L25"],
			powdersnow: ["8L6"],
			rest: ["8T", "8L18"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			rollout: ["8L1"],
			waterpulse: ["8T", "8L11"],
		},
	},
	walrein: {
		learnset: {
			aquatail: ["8T"],
			babydolleyes: ["8T"],
			blizzard: ["8L43"],
			bulldoze: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			iceball: ["8T"],
			icebeam: ["8T", "8L34"],
			icefang: ["8T"],
			icywind: ["8T"],
			ironhead: ["8T"],
			irontail: ["8T"],
			liquidation: ["8L25"],
			powdersnow: ["8L6"],
			rest: ["8T", "8L18"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			rollout: ["8L1"],
			waterpulse: ["8T", "8L11"],
		},
	},
	turtwig: {
		learnset: {
			bite: ["8L11"],
			bulldoze: ["8T", "8L18"],
			doubleedge: ["8L43"],
			earthpower: ["8T"],
			energyball: ["8T"],
			irontail: ["8T"],
			leafage: ["8L6"],
			leafblade: ["8L34"],
			rest: ["8T"],
			rocksmash: ["8T"],
			sleeppowder: ["8L25"],
			stealthrock: ["8T"],
			tackle: ["8L1"],
		},
	},
	grotle: {
		learnset: {
			bite: ["8L11"],
			bulldoze: ["8T", "8L18"],
			doubleedge: ["8L43"],
			earthpower: ["8T"],
			energyball: ["8T"],
			irontail: ["8T"],
			leafage: ["8L6"],
			leafblade: ["8L34"],
			rest: ["8T"],
			rocksmash: ["8T"],
			sleeppowder: ["8L25"],
			stealthrock: ["8T"],
			tackle: ["8L1"],
		},
	},
	torterra: {
		learnset: {
			bite: ["8L11"],
			bulldoze: ["8T", "8L18"],
			doubleedge: ["8L43"],
			earthpower: ["8T"],
			energyball: ["8T"],
			gigaimpact: ["8T"],
			headlongrush: ["8L57"],
			hyperbeam: ["8T"],
			ironhead: ["8T"],
			irontail: ["8T"],
			leafage: ["8L6"],
			leafblade: ["8L34"],
			outrage: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			sleeppowder: ["8L25"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			woodhammer: ["8L52"],
		},
	},
	chimchar: {
		learnset: {
			aerialace: ["8T"],
			bulkup: ["8T"],
			doubleedge: ["8L43"],
			ember: ["8L6"],
			firepunch: ["8T"],
			flamethrower: ["8T", "8L34"],
			flamewheel: ["8L18"],
			focusenergy: ["8T"],
			irontail: ["8T"],
			nastyplot: ["8L25"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowclaw: ["8T"],
			stealthrock: ["8T"],
			swift: ["8T", "8L11"],
			tackle: ["8L1"],
			thunderpunch: ["8T"],
		},
	},
	monferno: {
		learnset: {
			aerialace: ["8T"],
			bulkup: ["8T"],
			doubleedge: ["8L43"],
			ember: ["8L6"],
			firepunch: ["8T"],
			flamethrower: ["8T", "8L34"],
			flamewheel: ["8L18"],
			focusenergy: ["8T"],
			irontail: ["8T"],
			machpunch: ["8L16"],
			nastyplot: ["8L25"],
			poisonjab: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowclaw: ["8T"],
			stealthrock: ["8T"],
			swift: ["8T", "8L11"],
			tackle: ["8L1"],
			thunderpunch: ["8T"],
		},
	},
	infernape: {
		learnset: {
			aerialace: ["8T"],
			bulkup: ["8T"],
			bulldoze: ["8T"],
			calmmind: ["8T"],
			closecombat: ["8L57"],
			doubleedge: ["8L43"],
			drainpunch: ["8T"],
			ember: ["8L6"],
			firepunch: ["8T"],
			flamethrower: ["8T", "8L34"],
			flamewheel: ["8L18"],
			flareblitz: ["8L52"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			machpunch: ["8L16"],
			nastyplot: ["8L25"],
			poisonjab: ["8T"],
			ragingfury: ["8L46"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowclaw: ["8T"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			swift: ["8T", "8L11"],
			tackle: ["8L1"],
			thunderpunch: ["8T"],
		},
	},
	piplup: {
		learnset: {
			aerialace: ["8T", "8L11"],
			babydolleyes: ["8T"],
			bubble: ["8L6"],
			doubleedge: ["8L43"],
			icebeam: ["8T"],
			icywind: ["8T"],
			liquidation: ["8L34"],
			rest: ["8T"],
			rocksmash: ["8T"],
			roost: ["8L25"],
			stealthrock: ["8T"],
			tackle: ["8L1"],
			waterpulse: ["8T", "8L18"],
		},
	},
	prinplup: {
		learnset: {
			aerialace: ["8T", "8L11"],
			babydolleyes: ["8T"],
			bubble: ["8L6"],
			doubleedge: ["8L43"],
			icebeam: ["8T"],
			icywind: ["8T"],
			liquidation: ["8L34"],
			rest: ["8T"],
			rocksmash: ["8T"],
			roost: ["8L25"],
			shadowclaw: ["8T"],
			stealthrock: ["8T"],
			tackle: ["8L1"],
			waterpulse: ["8T", "8L18"],
		},
	},
	empoleon: {
		learnset: {
			aerialace: ["8T", "8L11"],
			babydolleyes: ["8T"],
			bubble: ["8L6"],
			bulldoze: ["8T"],
			doubleedge: ["8L43"],
			flashcannon: ["8T", "8L0"],
			gigaimpact: ["8T"],
			hydropump: ["8L52"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icywind: ["8T"],
			liquidation: ["8L34"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			roost: ["8L25"],
			shadowclaw: ["8T"],
			stealthrock: ["8T"],
			steelbeam: ["8T"],
			tackle: ["8L1"],
			waterpulse: ["8T", "8L18"],
			wavecrash: ["8L57"],
		},
	},
	starly: {
		learnset: {
			aerialace: ["8T", "8L9"],
			airslash: ["8L15"],
			bravebird: ["8L37"],
			doubleedge: ["8L29"],
			gigaimpact: ["8T", "8L47"],
			gust: ["8L1"],
			ominouswind: ["8T"],
			quickattack: ["8L5"],
			rest: ["8T"],
			roost: ["8L21"],
			swift: ["8T"],
		},
	},
	staravia: {
		learnset: {
			aerialace: ["8T", "8L9"],
			airslash: ["8L15"],
			bravebird: ["8L37"],
			doubleedge: ["8L29"],
			gigaimpact: ["8T", "8L47"],
			gust: ["8L1"],
			ominouswind: ["8T"],
			quickattack: ["8L5"],
			rest: ["8T"],
			roost: ["8L21"],
			swift: ["8T"],
		},
	},
	staraptor: {
		learnset: {
			aerialace: ["8T", "8L9"],
			airslash: ["8L15"],
			bravebird: ["8L37"],
			closecombat: ["8L0"],
			doubleedge: ["8L29"],
			focusenergy: ["8T"],
			gigaimpact: ["8T", "8L47"],
			gust: ["8L1"],
			hyperbeam: ["8T"],
			ominouswind: ["8T"],
			quickattack: ["8L5"],
			rest: ["8T"],
			roost: ["8L21"],
			swift: ["8T"],
		},
	},
	bidoof: {
		learnset: {
			aquatail: ["8T"],
			bite: ["8L10"],
			chargebeam: ["8T"],
			crunch: ["8L23"],
			doubleedge: ["8L40"],
			icebeam: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			rest: ["8T", "8L16"],
			rocksmash: ["8T"],
			rollout: ["8L1"],
			shadowball: ["8T"],
			stealthrock: ["8T"],
			swift: ["8T"],
			swordsdance: ["8L31"],
			tackle: ["8L5"],
			thunderbolt: ["8T"],
		},
	},
	bibarel: {
		learnset: {
			aquatail: ["8T", "8L23"],
			bite: ["8L10"],
			bulldoze: ["8T"],
			chargebeam: ["8T"],
			crunch: ["8L23"],
			doubleedge: ["8L40"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			rest: ["8T", "8L16"],
			rocksmash: ["8T"],
			rollout: ["8L1"],
			shadowball: ["8T"],
			stealthrock: ["8T"],
			swift: ["8T"],
			swordsdance: ["8L31"],
			tackle: ["8L5"],
			thunderbolt: ["8T"],
			waterpulse: ["8T", "8L0"],
		},
	},
	kricketot: {
		learnset: {
			absorb: ["8L1"],
			tackle: ["8L5"],
		},
	},
	kricketune: {
		learnset: {
			absorb: ["8L1"],
			aerialace: ["8T", "8L9"],
			bugbuzz: ["8L47"],
			falseswipe: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			leechlife: ["8T"],
			nightslash: ["8L21"],
			rest: ["8T"],
			rocksmash: ["8T"],
			slash: ["8L15"],
			swordsdance: ["8L37"],
			tackle: ["8L5"],
			xscissor: ["8T", "8L29"],
		},
	},
	shinx: {
		learnset: {
			babydolleyes: ["8T"],
			bite: ["8L9"],
			chargebeam: ["8T"],
			crunch: ["8L29"],
			firefang: ["8T"],
			icefang: ["8T"],
			irontail: ["8T"],
			playrough: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			snarl: ["8T"],
			swift: ["8T"],
			thunder: ["8L47"],
			thunderbolt: ["8T"],
			thunderfang: ["8T", "8L15"],
			thundershock: ["8L5"],
			thunderwave: ["8L21"],
			wildcharge: ["8T", "8L37"],
		},
	},
	luxio: {
		learnset: {
			babydolleyes: ["8T"],
			bite: ["8L9"],
			chargebeam: ["8T"],
			crunch: ["8L29"],
			firefang: ["8T"],
			icefang: ["8T"],
			irontail: ["8T"],
			playrough: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			snarl: ["8T"],
			swift: ["8T"],
			thunder: ["8L47"],
			thunderbolt: ["8T"],
			thunderfang: ["8T", "8L15"],
			thundershock: ["8L5"],
			thunderwave: ["8L21"],
			wildcharge: ["8T", "8L37"],
		},
	},
	luxray: {
		learnset: {
			babydolleyes: ["8T"],
			bite: ["8L9"],
			chargebeam: ["8T"],
			crunch: ["8L29"],
			firefang: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icefang: ["8T"],
			irontail: ["8T"],
			playrough: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			snarl: ["8T"],
			swift: ["8T"],
			thunder: ["8L47"],
			thunderbolt: ["8T"],
			thunderfang: ["8T", "8L15"],
			thundershock: ["8L5"],
			thunderwave: ["8L21"],
			wildcharge: ["8T", "8L37"],
		},
	},
	budew: {
		learnset: {
			absorb: ["8L6"],
			dazzlinggleam: ["8T"],
			energyball: ["8T", "8L43"],
			petaldance: ["8L52"],
			poisonjab: ["8T", "8L34"],
			poisonpowder: ["8L11"],
			poisonsting: ["8L1"],
			rest: ["8T"],
			shadowball: ["8T"],
			sludgebomb: ["8T"],
			spikes: ["8T"],
			stunspore: ["8L18"],
			swift: ["8T"],
			venoshock: ["8L25"],
		},
	},
	roserade: {
		learnset: {
			absorb: ["8L6"],
			dazzlinggleam: ["8T"],
			energyball: ["8T", "8L43"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			magicalleaf: ["8T"],
			petaldance: ["8L52"],
			poisonjab: ["8T", "8L34"],
			poisonpowder: ["8L11"],
			poisonsting: ["8L1"],
			rest: ["8T"],
			shadowball: ["8T"],
			sludgebomb: ["8T"],
			spikes: ["8T"],
			stunspore: ["8L18"],
			swift: ["8T"],
			venoshock: ["8L25"],
		},
	},
	cranidos: {
		learnset: {
			ancientpower: ["8L5"],
			bite: ["8L9"],
			bulldoze: ["8T"],
			crunch: ["8L29"],
			doubleedge: ["8L37"],
			earthpower: ["8T"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			focusenergy: ["8T"],
			headsmash: ["8L47"],
			icebeam: ["8T"],
			ironhead: ["8T", "8L21"],
			irontail: ["8T"],
			rest: ["8T"],
			rockslide: ["8T", "8L15"],
			rocksmash: ["8T"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	rampardos: {
		learnset: {
			ancientpower: ["8L5"],
			bite: ["8L9"],
			bulldoze: ["8T"],
			crunch: ["8L29"],
			doubleedge: ["8L37"],
			earthpower: ["8T"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			headsmash: ["8L47"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			ironhead: ["8T", "8L21"],
			irontail: ["8T"],
			outrage: ["8T"],
			powershift: ["8T"],
			rest: ["8T"],
			rockslide: ["8T", "8L15"],
			rocksmash: ["8T"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	shieldon: {
		learnset: {
			ancientpower: ["8L5"],
			bulldoze: ["8T"],
			doubleedge: ["8L47"],
			earthpower: ["8T", "8L29"],
			flamethrower: ["8T"],
			flashcannon: ["8T"],
			focusenergy: ["8T"],
			icebeam: ["8T"],
			irondefense: ["8L9"],
			ironhead: ["8T", "8L21"],
			irontail: ["8T"],
			rest: ["8T"],
			rockslide: ["8T", "8L15"],
			rocksmash: ["8T"],
			stealthrock: ["8T", "8L37"],
			steelbeam: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
		},
	},
	bastiodon: {
		learnset: {
			ancientpower: ["8L5"],
			bulldoze: ["8T"],
			doubleedge: ["8L47"],
			earthpower: ["8T", "8L29"],
			flamethrower: ["8T"],
			flashcannon: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			irondefense: ["8L9"],
			ironhead: ["8T", "8L21"],
			irontail: ["8T"],
			outrage: ["8T"],
			powershift: ["8T"],
			rest: ["8T"],
			rockslide: ["8T", "8L15"],
			rocksmash: ["8T"],
			stealthrock: ["8T", "8L37"],
			steelbeam: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
		},
	},
	burmy: {
		learnset: {
			strugglebug: ["8L1"],
		},
	},
	wormadam: {
		learnset: {
			bugbuzz: ["8L43"],
			confusion: ["8L11"],
			energyball: ["8T", "8L25"],
			gigaimpact: ["8T"],
			gust: ["8L6"],
			hyperbeam: ["8T"],
			magicalleaf: ["8T"],
			psychic: ["8T", "8L34"],
			rest: ["8T"],
			shadowball: ["8T"],
			silverwind: ["8L18"],
			strugglebug: ["8L1"],
		},
	},
	wormadamsandy: {
		learnset: {
			bugbuzz: ["8L43"],
			bulldoze: ["8T"],
			confusion: ["8L11"],
			earthpower: ["8T", "8L25"],
			gigaimpact: ["8T"],
			gust: ["8L6"],
			hyperbeam: ["8T"],
			psychic: ["8T", "8L34"],
			rest: ["8T"],
			shadowball: ["8T"],
			silverwind: ["8L18"],
			stealthrock: ["8T"],
			strugglebug: ["8L1"],
		},
	},
	wormadamtrash: {
		learnset: {
			bugbuzz: ["8L43"],
			confusion: ["8L11"],
			flashcannon: ["8T"],
			gigaimpact: ["8T"],
			gust: ["8L6"],
			hyperbeam: ["8T"],
			ironhead: ["8T", "8L25"],
			psychic: ["8T", "8L34"],
			rest: ["8T"],
			shadowball: ["8T"],
			silverwind: ["8L18"],
			stealthrock: ["8T"],
			steelbeam: ["8T"],
			strugglebug: ["8L1"],
		},
	},
	mothim: {
		learnset: {
			aerialace: ["8T"],
			airslash: ["8L25"],
			bugbuzz: ["8L43"],
			confusion: ["8L11"],
			energyball: ["8T"],
			gigaimpact: ["8T"],
			gust: ["8L6"],
			hyperbeam: ["8T"],
			ominouswind: ["8T"],
			psychic: ["8T", "8L34"],
			rest: ["8T"],
			shadowball: ["8T"],
			silverwind: ["8L18"],
			strugglebug: ["8L1"],
			swift: ["8T"],
		},
	},
	combee: {
		learnset: {
			gust: ["8L1"],
			ominouswind: ["8T"],
			strugglebug: ["8L6"],
			swift: ["8T"],
		},
	},
	vespiquen: {
		learnset: {
			aerialace: ["8T"],
			airslash: ["8L29"],
			bugbuzz: ["8L43"],
			gigaimpact: ["8T"],
			gust: ["8L1"],
			hyperbeam: ["8T"],
			ominouswind: ["8T"],
			pinmissile: ["8L11"],
			powergem: ["8L34"],
			powershift: ["8T"],
			recover: ["8L52"],
			rest: ["8T"],
			silverwind: ["8L18"],
			slash: ["8L25"],
			sludgebomb: ["8T"],
			strugglebug: ["8L6"],
			swift: ["8T"],
			xscissor: ["8T"],
		},
	},
	pachirisu: {
		learnset: {
			babydolleyes: ["8T", "8L21"],
			bite: ["8L9"],
			chargebeam: ["8T"],
			crunch: ["8L29"],
			irontail: ["8T"],
			playrough: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			spark: ["8L15"],
			swift: ["8T"],
			thunder: ["8L47"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			thundershock: ["8L5"],
			thunderwave: ["8L37"],
		},
	},
	buizel: {
		learnset: {
			aquajet: ["8L6"],
			aquatail: ["8T", "8L34"],
			bulkup: ["8T"],
			doublehit: ["8L25"],
			hydropump: ["8L43"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T"],
			swift: ["8T", "8L11"],
			waterpulse: ["8T", "8L18"],
		},
	},
	floatzel: {
		learnset: {
			aquajet: ["8L6"],
			aquatail: ["8T", "8L34"],
			bulkup: ["8T"],
			crunch: ["8L30"],
			doublehit: ["8L25"],
			gigaimpact: ["8T"],
			hydropump: ["8L43"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icefang: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T"],
			swift: ["8T", "8L11"],
			waterpulse: ["8T", "8L18"],
		},
	},
	cherubi: {
		learnset: {
			absorb: ["8L1"],
			dazzlinggleam: ["8T"],
			doubleedge: ["8L37"],
			drainingkiss: ["8L15"],
			energyball: ["8T", "8L21"],
			magicalleaf: ["8T"],
			petaldance: ["8L47"],
			rest: ["8T"],
			sleeppowder: ["8L29"],
			stunspore: ["8L9"],
			tackle: ["8L5"],
		},
	},
	cherrim: {
		learnset: {
			absorb: ["8L1"],
			dazzlinggleam: ["8T"],
			doubleedge: ["8L37"],
			drainingkiss: ["8L15"],
			energyball: ["8T", "8L21"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			magicalleaf: ["8T"],
			petaldance: ["8L47"],
			playrough: ["8T"],
			rest: ["8T"],
			sleeppowder: ["8L29"],
			stunspore: ["8L9"],
			tackle: ["8L5"],
		},
	},
	shellos: {
		learnset: {
			ancientpower: ["8L15"],
			earthpower: ["8T", "8L29"],
			hydropump: ["8L47"],
			icebeam: ["8T"],
			icywind: ["8T"],
			mudbomb: ["8L21"],
			mudslap: ["8L1"],
			recover: ["8L37"],
			rest: ["8T"],
			tackle: ["8L5"],
			waterpulse: ["8T", "8L9"],
		},
	},
	gastrodon: {
		learnset: {
			ancientpower: ["8L15"],
			bulldoze: ["8T"],
			earthpower: ["8T", "8L29"],
			gigaimpact: ["8T"],
			hydropump: ["8L47"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icywind: ["8T"],
			mudbomb: ["8L21"],
			mudslap: ["8L1"],
			recover: ["8L37"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			sludgebomb: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L5"],
			waterpulse: ["8T", "8L9"],
		},
	},
	ambipom: {
		learnset: {
			aerialace: ["8T"],
			doubleedge: ["8L43"],
			doublehit: ["8L25"],
			firepunch: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icepunch: ["8T"],
			irontail: ["8T", "8L34"],
			mudbomb: ["8L18"],
			nastyplot: ["8L6"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			shadowclaw: ["8T"],
			swift: ["8T", "8L11"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			waterpulse: ["8T"],
		},
	},
	drifloon: {
		learnset: {
			astonish: ["8L9"],
			calmmind: ["8T", "8L15"],
			chargebeam: ["8T"],
			confusion: ["8L1"],
			extrasensory: ["8L29"],
			focusenergy: ["8T"],
			hex: ["8L21"],
			hypnosis: ["8L5"],
			icywind: ["8T"],
			mysticalfire: ["8T", "8L25"],
			ominouswind: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			selfdestruct: ["8L47"],
			shadowball: ["8T", "8L37"],
			swift: ["8T"],
			thunderbolt: ["8T"],
		},
	},
	drifblim: {
		learnset: {
			astonish: ["8L9"],
			calmmind: ["8T", "8L15"],
			chargebeam: ["8T"],
			confusion: ["8L1"],
			extrasensory: ["8L29"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hex: ["8L21"],
			hyperbeam: ["8T"],
			hypnosis: ["8L5"],
			icywind: ["8T"],
			mysticalfire: ["8T", "8L25"],
			ominouswind: ["8T"],
			powershift: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			selfdestruct: ["8L47"],
			shadowball: ["8T", "8L37"],
			swift: ["8T"],
			thunderbolt: ["8T"],
		},
	},
	buneary: {
		learnset: {
			babydolleyes: ["8T", "8L5"],
			chargebeam: ["8T"],
			doubleedge: ["8L40"],
			doublehit: ["8L23"],
			drainingkiss: ["8L16"],
			drainpunch: ["8T"],
			firepunch: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			irontail: ["8T"],
			playrough: ["8T", "8L31"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			swift: ["8T", "8L10"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			waterpulse: ["8T"],
		},
	},
	lopunny: {
		learnset: {
			babydolleyes: ["8T", "8L5"],
			chargebeam: ["8T"],
			closecombat: ["8L40"],
			doubleedge: ["8L40"],
			doublehit: ["8L23"],
			drainingkiss: ["8L16"],
			drainpunch: ["8T"],
			firepunch: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			irontail: ["8T"],
			machpunch: ["8L1"],
			playrough: ["8T", "8L31"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			swift: ["8T", "8L10"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			waterpulse: ["8T"],
		},
	},
	mismagius: {
		learnset: {
			aerialace: ["8T"],
			calmmind: ["8T"],
			chargebeam: ["8T"],
			confusion: ["8L6"],
			darkpulse: ["8T"],
			dazzlinggleam: ["8T"],
			energyball: ["8T"],
			extrasensory: ["8L25"],
			gigaimpact: ["8T"],
			hex: ["8L18"],
			hyperbeam: ["8T"],
			hypnosis: ["8L11"],
			icywind: ["8T"],
			magicalleaf: ["8T"],
			mysticalfire: ["8T"],
			ominouswind: ["8T"],
			powergem: ["8L34"],
			psychic: ["8T"],
			rest: ["8T"],
			shadowball: ["8T", "8L43"],
			shadowsneak: ["8L1"],
			swift: ["8T"],
			thunderbolt: ["8T"],
		},
	},
	honchkrow: {
		learnset: {
			aerialace: ["8T", "8L18"],
			airslash: ["8L30"],
			bravebird: ["8L52"],
			calmmind: ["8T"],
			darkpulse: ["8T", "8L43"],
			gigaimpact: ["8T"],
			gust: ["8L1"],
			hyperbeam: ["8T"],
			icywind: ["8T"],
			nastyplot: ["8L34"],
			nightslash: ["8L25"],
			ominouswind: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			roost: ["8L11"],
			shadowball: ["8T"],
			snarl: ["8T", "8L6"],
			swift: ["8T"],
		},
	},
	glameow: {
		learnset: {
			aerialace: ["8T"],
			doubleedge: ["8L40"],
			hypnosis: ["8L5"],
			irontail: ["8T"],
			nastyplot: ["8L10"],
			nightslash: ["8L23"],
			playrough: ["8T", "8L31"],
			rest: ["8T"],
			shadowball: ["8T"],
			shadowclaw: ["8T"],
			slash: ["8L16"],
			swift: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			waterpulse: ["8T"],
		},
	},
	purugly: {
		learnset: {
			aerialace: ["8T"],
			bulldoze: ["8T"],
			doubleedge: ["8L40"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			hypnosis: ["8L5"],
			irontail: ["8T"],
			nastyplot: ["8L10"],
			nightslash: ["8L23"],
			playrough: ["8T", "8L31"],
			rest: ["8T"],
			shadowball: ["8T"],
			shadowclaw: ["8T"],
			slash: ["8L16"],
			swift: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			waterpulse: ["8T"],
		},
	},
	chingling: {
		learnset: {
			calmmind: ["8T"],
			chargebeam: ["8T"],
			confusion: ["8L6"],
			dazzlinggleam: ["8T"],
			doubleedge: ["8L43"],
			energyball: ["8T"],
			extrasensory: ["8L25"],
			hypnosis: ["8L18"],
			icywind: ["8T"],
			ominouswind: ["8T", "8L11"],
			psychic: ["8T"],
			recover: ["8L34"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			zenheadbutt: ["8T"],
		},
	},
	stunky: {
		learnset: {
			acidspray: ["8L6"],
			darkpulse: ["8T"],
			doubleedge: ["8L43"],
			flamethrower: ["8T"],
			focusenergy: ["8T"],
			irontail: ["8T"],
			nightslash: ["8L25"],
			playrough: ["8T"],
			poisongas: ["8L11"],
			poisonjab: ["8T", "8L34"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			shadowclaw: ["8T"],
			sludgebomb: ["8T"],
			snarl: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			venoshock: ["8L18"],
		},
	},
	skuntank: {
		learnset: {
			acidspray: ["8L6"],
			darkpulse: ["8T"],
			doubleedge: ["8L43"],
			flamethrower: ["8T", "8L34"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			nightslash: ["8L25"],
			playrough: ["8T"],
			poisongas: ["8L11"],
			poisonjab: ["8T", "8L34"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			shadowclaw: ["8T"],
			sludgebomb: ["8T"],
			snarl: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			venoshock: ["8L18"],
		},
	},
	bronzor: {
		learnset: {
			bulldoze: ["8T"],
			chargebeam: ["8T"],
			confusion: ["8L6"],
			extrasensory: ["8L43"],
			flashcannon: ["8T", "8L34"],
			hex: ["8L18"],
			hypnosis: ["8L25"],
			irondefense: ["8L11"],
			psychic: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			shadowball: ["8T"],
			stealthrock: ["8T"],
			steelbeam: ["8T"],
			tackle: ["8L1"],
		},
	},
	bronzong: {
		learnset: {
			bulldoze: ["8T"],
			chargebeam: ["8T"],
			confusion: ["8L6"],
			extrasensory: ["8L43"],
			flashcannon: ["8T", "8L34"],
			gigaimpact: ["8T"],
			hex: ["8L18"],
			hyperbeam: ["8T"],
			hypnosis: ["8L25"],
			irondefense: ["8L11"],
			ironhead: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			stealthrock: ["8T"],
			steelbeam: ["8T"],
			tackle: ["8L1"],
			zenheadbutt: ["8T"],
		},
	},
	bonsly: {
		learnset: {
			calmmind: ["8T"],
			doubleedge: ["8L37"],
			earthpower: ["8T"],
			headsmash: ["8L47"],
			irondefense: ["8L21"],
			mimic: ["8L29"],
			rest: ["8T"],
			rockslide: ["8T", "8L15"],
			rollout: ["8L1"],
			stealthrock: ["8T", "8L9"],
			tackle: ["8L5"],
		},
	},
	mimejr: {
		learnset: {
			calmmind: ["8T", "8L43"],
			chargebeam: ["8T"],
			confusion: ["8L1"],
			dazzlinggleam: ["8T"],
			drainpunch: ["8T"],
			hypnosis: ["8L6"],
			icywind: ["8T"],
			irondefense: ["8L11"],
			mimic: ["8L25"],
			psychic: ["8T", "8L34"],
			rest: ["8T"],
			shadowball: ["8T"],
			thunderbolt: ["8T"],
			zenheadbutt: ["8T", "8L18"],
		},
	},
	happiny: {
		learnset: {
			babydolleyes: ["8T", "8L11"],
			calmmind: ["8T", "8L25"],
			doubleedge: ["8L43"],
			drainingkiss: ["8L18"],
			drainpunch: ["8T"],
			fairywind: ["8L6"],
			flamethrower: ["8T"],
			icywind: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			shadowball: ["8T"],
			softboiled: ["8L34"],
			tackle: ["8L1"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	chatot: {
		learnset: {
			aerialace: ["8T"],
			aircutter: ["8L11"],
			airslash: ["8L25"],
			gust: ["8L1"],
			hurricane: ["8L52"],
			mimic: ["8L30"],
			nastyplot: ["8L34"],
			ominouswind: ["8T"],
			playrough: ["8T", "8L43"],
			powershift: ["8T"],
			rest: ["8T"],
			roost: ["8L18"],
			snarl: ["8T"],
			swift: ["8T", "8L6"],
		},
	},
	spiritomb: {
		learnset: {
			calmmind: ["8T"],
			darkpulse: ["8T", "8L34"],
			extrasensory: ["8L25"],
			gigaimpact: ["8T"],
			hex: ["8L11"],
			hyperbeam: ["8T"],
			hypnosis: ["8L6"],
			icywind: ["8T"],
			nastyplot: ["8L18"],
			ominouswind: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			shadowball: ["8T", "8L43"],
			shadowsneak: ["8L1"],
			snarl: ["8T"],
			waterpulse: ["8T"],
		},
	},
	gible: {
		learnset: {
			aerialace: ["8T"],
			bulldoze: ["8T", "8L9"],
			doubleedge: ["8L37"],
			dracometeor: ["8T"],
			dragonclaw: ["8L21"],
			earthpower: ["8T", "8L29"],
			flamethrower: ["8T"],
			ironhead: ["8T"],
			irontail: ["8T"],
			outrage: ["8T", "8L47"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			slash: ["8L15"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			twister: ["8L5"],
		},
	},
	gabite: {
		learnset: {
			aerialace: ["8T"],
			bulldoze: ["8T", "8L9"],
			doubleedge: ["8L37"],
			dracometeor: ["8T"],
			dragonclaw: ["8L21"],
			earthpower: ["8T", "8L29"],
			flamethrower: ["8T"],
			ironhead: ["8T"],
			irontail: ["8T"],
			outrage: ["8T", "8L47"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowclaw: ["8T"],
			slash: ["8L15"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			twister: ["8L5"],
		},
	},
	garchomp: {
		learnset: {
			aerialace: ["8T"],
			aquatail: ["8T"],
			bulldoze: ["8T", "8L9"],
			doubleedge: ["8L37"],
			dracometeor: ["8T"],
			dragonclaw: ["8L21"],
			earthpower: ["8T", "8L29"],
			falseswipe: ["8T"],
			firefang: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			ironhead: ["8T"],
			irontail: ["8T"],
			outrage: ["8T", "8L47"],
			poisonjab: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowclaw: ["8T"],
			slash: ["8L15"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			twister: ["8L5"],
		},
	},
	munchlax: {
		learnset: {
			bite: ["8L21"],
			bulldoze: ["8T", "8L15"],
			doubleedge: ["8L46"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T", "8L57"],
			highhorsepower: ["8T", "8L37"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			psychic: ["8T"],
			rest: ["8T", "8L9"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			rollout: ["8L1"],
			shadowball: ["8T"],
			tackle: ["8L5"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T", "8L29"],
		},
	},
	riolu: {
		learnset: {
			aurasphere: ["8L21"],
			bite: ["8L9"],
			bulkup: ["8T", "8L37"],
			bulldoze: ["8T"],
			bulletpunch: ["8L5"],
			closecombat: ["8L47"],
			crunch: ["8L29"],
			drainpunch: ["8T"],
			focusenergy: ["8T"],
			icepunch: ["8T"],
			irondefense: ["8L15"],
			irontail: ["8T"],
			poisonjab: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T", "8L1"],
			shadowclaw: ["8T"],
			swift: ["8T"],
			thunderpunch: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	lucario: {
		learnset: {
			aurasphere: ["8L21"],
			bite: ["8L9"],
			bulkup: ["8T", "8L37"],
			bulldoze: ["8T"],
			bulletpunch: ["8L5"],
			calmmind: ["8T"],
			closecombat: ["8L47"],
			crunch: ["8L29"],
			darkpulse: ["8T"],
			dragonpulse: ["8L40"],
			drainpunch: ["8T"],
			flashcannon: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icepunch: ["8T"],
			irondefense: ["8L15"],
			irontail: ["8T"],
			machpunch: ["8L19"],
			poisonjab: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T", "8L1"],
			shadowball: ["8T"],
			shadowclaw: ["8T"],
			steelbeam: ["8T"],
			stoneedge: ["8T"],
			swift: ["8T"],
			thunderpunch: ["8T"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	hippopotas: {
		learnset: {
			bite: ["8L11"],
			bulldoze: ["8T"],
			crunch: ["8L25"],
			doubleedge: ["8L43"],
			earthpower: ["8T"],
			highhorsepower: ["8T", "8L34"],
			irontail: ["8T"],
			mudbomb: ["8L18"],
			rest: ["8T", "8L6"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			stealthrock: ["8T"],
			tackle: ["8L1"],
			waterpulse: ["8T"],
		},
	},
	hippowdon: {
		learnset: {
			bite: ["8L11"],
			bulldoze: ["8T"],
			crunch: ["8L25"],
			doubleedge: ["8L43"],
			earthpower: ["8T"],
			firefang: ["8T"],
			gigaimpact: ["8T"],
			highhorsepower: ["8T", "8L34"],
			hyperbeam: ["8T"],
			icefang: ["8T"],
			ironhead: ["8T"],
			irontail: ["8T"],
			mudbomb: ["8L18"],
			rest: ["8T", "8L6"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			thunderfang: ["8T"],
			waterpulse: ["8T"],
		},
	},
	skorupi: {
		learnset: {
			aerialace: ["8T"],
			aquatail: ["8T"],
			bite: ["8L6"],
			crosspoison: ["8L18"],
			crunch: ["8L43"],
			darkpulse: ["8T"],
			falseswipe: ["8T"],
			irontail: ["8T"],
			poisonjab: ["8T"],
			poisonsting: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			sludgebomb: ["8T"],
			swordsdance: ["8L25"],
			venoshock: ["8L11"],
			xscissor: ["8T", "8L34"],
		},
	},
	drapion: {
		learnset: {
			aerialace: ["8T"],
			aquatail: ["8T"],
			bite: ["8L6"],
			bulldoze: ["8T"],
			crosspoison: ["8L18"],
			crunch: ["8L43"],
			darkpulse: ["8T"],
			falseswipe: ["8T"],
			firefang: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icefang: ["8T"],
			irontail: ["8T"],
			leechlife: ["8T"],
			poisonjab: ["8T"],
			poisonsting: ["8L1"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			sludgebomb: ["8T"],
			snarl: ["8T"],
			swordsdance: ["8L25"],
			thunderfang: ["8T"],
			venoshock: ["8L11"],
			xscissor: ["8T", "8L34"],
		},
	},
	croagunk: {
		learnset: {
			bulkup: ["8T"],
			bulldoze: ["8T"],
			closecombat: ["8L47"],
			darkpulse: ["8T"],
			drainpunch: ["8T"],
			earthpower: ["8T", "8L37"],
			icepunch: ["8T"],
			icywind: ["8T"],
			mudbomb: ["8L9"],
			nastyplot: ["8L21"],
			poisonjab: ["8T", "8L29"],
			poisonsting: ["8L1"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T", "8L5"],
			shadowball: ["8T"],
			sludgebomb: ["8T"],
			thunderpunch: ["8T"],
			venoshock: ["8L15"],
			xscissor: ["8T"],
		},
	},
	toxicroak: {
		learnset: {
			bulkup: ["8T"],
			bulldoze: ["8T"],
			closecombat: ["8L47"],
			darkpulse: ["8T"],
			drainpunch: ["8T"],
			earthpower: ["8T", "8L37"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			mudbomb: ["8L9"],
			nastyplot: ["8L21"],
			poisonjab: ["8T", "8L29"],
			poisonsting: ["8L1"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T", "8L5"],
			shadowball: ["8T"],
			sludgebomb: ["8T"],
			stoneedge: ["8T"],
			thunderpunch: ["8T"],
			venoshock: ["8L15"],
			xscissor: ["8T"],
		},
	},
	carnivine: {
		learnset: {
			absorb: ["8L1"],
			acidspray: ["8L6"],
			bite: ["8L11"],
			crunch: ["8L25"],
			energyball: ["8T", "8L43"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			leechlife: ["8T"],
			magicalleaf: ["8T"],
			rest: ["8T"],
			sleeppowder: ["8L34"],
			sludgebomb: ["8T"],
			stunspore: ["8L18"],
		},
	},
	finneon: {
		learnset: {
			airslash: ["8L25"],
			aquatail: ["8T"],
			babydolleyes: ["8T"],
			bubble: ["8L1"],
			gust: ["8L6"],
			hydropump: ["8L43"],
			icebeam: ["8T"],
			icywind: ["8T"],
			ominouswind: ["8T"],
			rest: ["8T"],
			roost: ["8L34"],
			silverwind: ["8L18"],
			swift: ["8T"],
			waterpulse: ["8T", "8L11"],
		},
	},
	lumineon: {
		learnset: {
			aerialace: ["8T"],
			airslash: ["8L25"],
			aquatail: ["8T"],
			babydolleyes: ["8T"],
			bubble: ["8L1"],
			gigaimpact: ["8T"],
			gust: ["8L6"],
			hydropump: ["8L43"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icywind: ["8T"],
			ominouswind: ["8T"],
			rest: ["8T"],
			roost: ["8L34"],
			silverwind: ["8L18"],
			swift: ["8T"],
			waterpulse: ["8T", "8L11"],
		},
	},
	mantyke: {
		learnset: {
			aerialace: ["8T", "8L9"],
			airslash: ["8L21"],
			bubble: ["8L5"],
			bulldoze: ["8T"],
			doubleedge: ["8L47"],
			hydropump: ["8L37"],
			icebeam: ["8T"],
			icywind: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			roost: ["8L29"],
			swift: ["8T"],
			tackle: ["8L1"],
			waterpulse: ["8T", "8L15"],
		},
	},
	snover: {
		learnset: {
			blizzard: ["8L34"],
			energyball: ["8T", "8L25"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			iceshard: ["8L11"],
			iciclecrash: ["8L18"],
			icywind: ["8T"],
			irontail: ["8T"],
			leafage: ["8L6"],
			magicalleaf: ["8T"],
			powdersnow: ["8L1"],
			rest: ["8T"],
			shadowball: ["8T"],
			waterpulse: ["8T"],
			woodhammer: ["8L43"],
		},
	},
	abomasnow: {
		learnset: {
			blizzard: ["8L34"],
			bulldoze: ["8T"],
			earthpower: ["8T"],
			energyball: ["8T", "8L25"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			iceshard: ["8L11"],
			iciclecrash: ["8L18"],
			icywind: ["8T"],
			irontail: ["8T"],
			leafage: ["8L6"],
			magicalleaf: ["8T"],
			outrage: ["8T"],
			powdersnow: ["8L1"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			waterpulse: ["8T"],
			woodhammer: ["8L43"],
		},
	},
	weavile: {
		learnset: {
			aerialace: ["8T"],
			blizzard: ["8L43"],
			calmmind: ["8T"],
			darkpulse: ["8T"],
			falseswipe: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			iceshard: ["8L6"],
			icywind: ["8T"],
			irontail: ["8T"],
			nightslash: ["8L38"],
			poisonjab: ["8T", "8L25"],
			psychocut: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			shadowclaw: ["8T"],
			slash: ["8L18"],
			snarl: ["8T"],
			swift: ["8T", "8L11"],
			swordsdance: ["8L34"],
			xscissor: ["8T"],
		},
	},
	magnezone: {
		learnset: {
			chargebeam: ["8T"],
			flashcannon: ["8T", "8L25"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			ironhead: ["8T"],
			rest: ["8T"],
			spark: ["8L18"],
			steelbeam: ["8T"],
			swift: ["8T"],
			tackle: ["8L6"],
			thunder: ["8L43"],
			thunderbolt: ["8T", "8L34"],
			thundershock: ["8L1"],
			thunderwave: ["8L11"],
			triattack: ["8T", "8L25"],
			wildcharge: ["8T"],
		},
	},
	lickilicky: {
		learnset: {
			aquatail: ["8T"],
			bulldoze: ["8T", "8L11"],
			doubleedge: ["8L25"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T", "8L43"],
			hyperbeam: ["8T"],
			iceball: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			rest: ["8T", "8L6"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			rollout: ["8L34"],
			shadowball: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T", "8L18"],
		},
	},
	rhyperior: {
		learnset: {
			aquatail: ["8T"],
			bulldoze: ["8T", "8L6"],
			doubleedge: ["8L43"],
			earthpower: ["8T"],
			firefang: ["8T"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			flashcannon: ["8T"],
			gigaimpact: ["8T", "8L52"],
			highhorsepower: ["8T", "8L34"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icefang: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			ironhead: ["8T"],
			irontail: ["8T"],
			megahorn: ["8T"],
			outrage: ["8T"],
			poisonjab: ["8T"],
			rest: ["8T"],
			rockslide: ["8T", "8L25"],
			rocksmash: ["8T", "8L11"],
			shadowclaw: ["8T"],
			stealthrock: ["8T", "8L18"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			thunderfang: ["8T"],
			thunderpunch: ["8T"],
		},
	},
	tangrowth: {
		learnset: {
			absorb: ["8L1"],
			acidspray: ["8L15"],
			aerialace: ["8T"],
			ancientpower: ["8L34"],
			bulldoze: ["8T"],
			doublehit: ["8L18"],
			energyball: ["8T", "8L25"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			poisonjab: ["8T"],
			poisonpowder: ["8L11"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			sleeppowder: ["8L43"],
			sludgebomb: ["8T", "8L52"],
			stunspore: ["8L6"],
		},
	},
	electivire: {
		learnset: {
			bulldoze: ["8T"],
			chargebeam: ["8T"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icepunch: ["8T"],
			irontail: ["8T"],
			psychic: ["8T"],
			quickattack: ["8L6"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			spark: ["8L11"],
			swift: ["8T"],
			thunder: ["8L43"],
			thunderbolt: ["8T", "8L34"],
			thunderpunch: ["8T", "8L25"],
			thundershock: ["8L1"],
			thunderwave: ["8L18"],
			wildcharge: ["8T"],
		},
	},
	magmortar: {
		learnset: {
			bulldoze: ["8T"],
			ember: ["8L1"],
			fireblast: ["8L43"],
			firepunch: ["8T", "8L25"],
			flamethrower: ["8T", "8L34"],
			flamewheel: ["8L11"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			mysticalfire: ["8T"],
			poisongas: ["8L18"],
			psychic: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			tackle: ["8L6"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
		},
	},
	togekiss: {
		learnset: {
			aerialace: ["8T"],
			aircutter: ["8L11"],
			airslash: ["8L25"],
			babydolleyes: ["8T", "8L25"],
			calmmind: ["8T", "8L18"],
			dazzlinggleam: ["8T"],
			drainingkiss: ["8L11"],
			drainpunch: ["8T"],
			extrasensory: ["8L34"],
			fairywind: ["8L6"],
			flamethrower: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			magicalleaf: ["8T"],
			moonblast: ["8L43"],
			mysticalfire: ["8T"],
			ominouswind: ["8T"],
			playrough: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			triattack: ["8T"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	yanmega: {
		learnset: {
			aerialace: ["8T"],
			airslash: ["8L25"],
			ancientpower: ["8L34"],
			bugbuzz: ["8L43"],
			crunch: ["8L43"],
			gigaimpact: ["8T"],
			gust: ["8L6"],
			hyperbeam: ["8T"],
			hypnosis: ["8L18"],
			leechlife: ["8T"],
			ominouswind: ["8T"],
			psychic: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			shadowball: ["8T"],
			silverwind: ["8L11"],
			swift: ["8T"],
		},
	},
	leafeon: {
		learnset: {
			aerialace: ["8T"],
			babydolleyes: ["8T", "8L18"],
			calmmind: ["8T", "8L34"],
			doubleedge: ["8L43"],
			energyball: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			leafage: ["8L0"],
			leafblade: ["8L25"],
			magicalleaf: ["8T"],
			mimic: ["8L25"],
			quickattack: ["8L6"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			swift: ["8T", "8L11"],
			tackle: ["8L1"],
			xscissor: ["8T"],
		},
	},
	glaceon: {
		learnset: {
			aquatail: ["8T"],
			babydolleyes: ["8T", "8L18"],
			calmmind: ["8T", "8L34"],
			doubleedge: ["8L43"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T", "8L25"],
			icefang: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			mimic: ["8L25"],
			powdersnow: ["8L0"],
			quickattack: ["8L6"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			swift: ["8T", "8L11"],
			tackle: ["8L1"],
			waterpulse: ["8T"],
		},
	},
	gliscor: {
		learnset: {
			aerialace: ["8T", "8L11"],
			aquatail: ["8T"],
			bulldoze: ["8T"],
			darkpulse: ["8T"],
			earthpower: ["8T", "8L52"],
			falseswipe: ["8T"],
			firefang: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icefang: ["8T"],
			irontail: ["8T"],
			mudbomb: ["8L18"],
			pinmissile: ["8L20"],
			poisonjab: ["8T", "8L34"],
			poisonsting: ["8L1"],
			powershift: ["8T"],
			quickattack: ["8L6"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			slash: ["8L25"],
			sludgebomb: ["8T"],
			spikes: ["8T"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			swift: ["8T"],
			swordsdance: ["8L30"],
			thunderfang: ["8T"],
			xscissor: ["8T", "8L43"],
		},
	},
	mamoswine: {
		learnset: {
			ancientpower: ["8L34"],
			babydolleyes: ["8T"],
			blizzard: ["8L43"],
			bulldoze: ["8T", "8L11"],
			doubleedge: ["8L52"],
			earthpower: ["8T"],
			gigaimpact: ["8T"],
			highhorsepower: ["8T", "8L25"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icefang: ["8T"],
			iceshard: ["8L6"],
			iciclecrash: ["8L18"],
			icywind: ["8T"],
			ironhead: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
		},
	},
	porygonz: {
		learnset: {
			aerialace: ["8T"],
			chargebeam: ["8T"],
			darkpulse: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T", "8L47"],
			icebeam: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			powershift: ["8T"],
			psychic: ["8T"],
			recover: ["8L37"],
			rest: ["8T"],
			shadowball: ["8T"],
			spark: ["8L15"],
			swift: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T", "8L29"],
			thundershock: ["8L5"],
			thunderwave: ["8L9"],
			triattack: ["8T", "8L21"],
			zenheadbutt: ["8T"],
		},
	},
	gallade: {
		learnset: {
			aerialace: ["8T"],
			bulkup: ["8T"],
			bulldoze: ["8T"],
			calmmind: ["8T", "8L25"],
			chargebeam: ["8T"],
			closecombat: ["8L52"],
			confusion: ["8L1"],
			dazzlinggleam: ["8T"],
			drainingkiss: ["8L11"],
			drainpunch: ["8T"],
			energyball: ["8T"],
			falseswipe: ["8T"],
			firepunch: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			hypnosis: ["8L18"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			leafblade: ["8L43"],
			magicalleaf: ["8T"],
			poisonjab: ["8T"],
			psychic: ["8T", "8L34"],
			psychocut: ["8T", "8L18"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			slash: ["8L0"],
			stoneedge: ["8T"],
			swift: ["8T"],
			swordsdance: ["8L30"],
			teleport: ["8L6"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			xscissor: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	probopass: {
		learnset: {
			bulldoze: ["8T"],
			earthpower: ["8T", "8L43"],
			firepunch: ["8T"],
			flashcannon: ["8T", "8L38"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icepunch: ["8T"],
			irondefense: ["8L18"],
			ironhead: ["8T"],
			powergem: ["8L34"],
			powershift: ["8T"],
			rest: ["8T"],
			rockslide: ["8T", "8L25"],
			rocksmash: ["8T"],
			spark: ["8L11"],
			stealthrock: ["8T"],
			steelbeam: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			thunderwave: ["8L6"],
			triattack: ["8T", "8L34"],
		},
	},
	dusknoir: {
		learnset: {
			absorb: ["8L1"],
			bulldoze: ["8T"],
			calmmind: ["8T"],
			chargebeam: ["8T"],
			darkpulse: ["8T", "8L25"],
			firepunch: ["8T"],
			gigaimpact: ["8T"],
			hex: ["8L11"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			leechlife: ["8T", "8L18"],
			ominouswind: ["8T"],
			powershift: ["8T"],
			psychic: ["8T", "8L43"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T", "8L34"],
			shadowsneak: ["8L6"],
			thunderpunch: ["8T"],
		},
	},
	froslass: {
		learnset: {
			bite: ["8L11"],
			blizzard: ["8L43"],
			crunch: ["8L25"],
			gigaimpact: ["8T"],
			hex: ["8L18"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icefang: ["8T", "8L18"],
			icepunch: ["8T"],
			iceshard: ["8L6"],
			iciclecrash: ["8L34"],
			icywind: ["8T"],
			ominouswind: ["8T"],
			powdersnow: ["8L1"],
			psychic: ["8T"],
			rest: ["8T"],
			shadowball: ["8T", "8L25"],
			spikes: ["8T"],
			thunderbolt: ["8T"],
			waterpulse: ["8T"],
		},
	},
	rotom: {
		learnset: {
			chargebeam: ["8T", "8L6"],
			darkpulse: ["8T"],
			hex: ["8L11"],
			ominouswind: ["8T"],
			rest: ["8T"],
			shadowball: ["8T", "8L25"],
			swift: ["8T"],
			thunder: ["8L43"],
			thunderbolt: ["8T", "8L34"],
			thundershock: ["8L1"],
			thunderwave: ["8L18"],
		},
	},
	rotomheat: {
		learnset: {
			overheat: ["8R"],
		},
	},
	rotomwash: {
		learnset: {
			hydropump: ["8R"],
		},
	},
	rotomfrost: {
		learnset: {
			blizzard: ["8R"],
		},
	},
	rotomfan: {
		learnset: {
			airslash: ["8R"],
		},
	},
	rotommow: {
		learnset: {
			leafstorm: ["8R"],
		},
	},
	uxie: {
		inherit: true,
		learnset: {
			calmmind: ["8T", "8L36"],
			chargebeam: ["8T"],
			confusion: ["8L1"],
			dazzlinggleam: ["8T"],
			doublehit: ["8L12"],
			drainpunch: ["8T"],
			energyball: ["8T"],
			extrasensory: ["8L27", "8S7"],
			firepunch: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			hypnosis: ["8L57", "8S7"],
			icepunch: ["8T"],
			irontail: ["8T"],
			mysticalpower: ["8L46", "8S7"],
			playrough: ["8T"],
			powershift: ["8T"],
			psychic: ["8T"],
			psychocut: ["8T"],
			rest: ["8T", "8L19"],
			shadowball: ["8T"],
			stealthrock: ["8T"],
			swift: ["8T", "8L6", "8S7"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			triattack: ["8T", "8L32"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	mesprit: {
		inherit: true,
		learnset: {
			calmmind: ["8T", "8L36"],
			chargebeam: ["8T"],
			confusion: ["8L1"],
			dazzlinggleam: ["8T"],
			doublehit: ["8L12"],
			drainpunch: ["8T"],
			energyball: ["8T"],
			extrasensory: ["8L27", "8S7"],
			firepunch: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icepunch: ["8T"],
			irontail: ["8T"],
			mysticalpower: ["8L46", "8S7"],
			playrough: ["8T"],
			psychic: ["8T"],
			psychocut: ["8T"],
			recover: ["8L57", "8S7"],
			rest: ["8T", "8L19"],
			shadowball: ["8T"],
			stealthrock: ["8T"],
			swift: ["8T", "8L6", "8S7"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			triattack: ["8T", "8L32"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	azelf: {
		inherit: true,
		learnset: {
			calmmind: ["8T"],
			chargebeam: ["8T"],
			confusion: ["8L1"],
			dazzlinggleam: ["8T"],
			doublehit: ["8L12", "8S7"],
			drainpunch: ["8T"],
			energyball: ["8T"],
			extrasensory: ["8L27", "8S7"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icepunch: ["8T"],
			irontail: ["8T"],
			mysticalpower: ["8L46", "8S7"],
			nastyplot: ["8L36"],
			playrough: ["8T"],
			powershift: ["8T"],
			psychic: ["8T"],
			psychocut: ["8T"],
			rest: ["8T", "8L19"],
			selfdestruct: ["8L57"],
			shadowball: ["8T"],
			stealthrock: ["8T"],
			swift: ["8T", "8L6", "8S7"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			triattack: ["8T", "8L32"],
			waterpulse: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	dialga: {
		inherit: true,
		learnset: {
			aerialace: ["8T"],
			ancientpower: ["8L6"],
			bulkup: ["8T"],
			bulldoze: ["8T"],
			dracometeor: ["8T"],
			dragonclaw: ["8L19"],
			dragonpulse: ["8L36"],
			earthpower: ["8T", "8L42", "8S14"],
			flamethrower: ["8T"],
			flashcannon: ["8T", "8L55", "8S14"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			ironhead: ["8T"],
			irontail: ["8T", "8L47", "8S14"],
			outrage: ["8T"],
			powergem: ["8L27"],
			rest: ["8T"],
			roaroftime: ["8L60", "8S14"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowclaw: ["8T"],
			slash: ["8L12"],
			stealthrock: ["8T"],
			steelbeam: ["8T"],
			stoneedge: ["8T"],
			swift: ["8T"],
			thunderbolt: ["8T"],
			twister: ["8L1"],
		},
	},
	palkia: {
		inherit: true,
		learnset: {
			aerialace: ["8T"],
			ancientpower: ["8L6"],
			aquatail: ["8T", "8L47", "8S14"],
			bulkup: ["8T"],
			bulldoze: ["8T"],
			dracometeor: ["8T"],
			dragonclaw: ["8L19"],
			dragonpulse: ["8L36"],
			earthpower: ["8T", "8L42", "8S14"],
			flamethrower: ["8T"],
			gigaimpact: ["8T"],
			hydropump: ["8L55", "8S14"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			outrage: ["8T"],
			powergem: ["8L27"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowclaw: ["8T"],
			slash: ["8L12"],
			spacialrend: ["8L60", "8S14"],
			stoneedge: ["8T"],
			swift: ["8T"],
			thunderbolt: ["8T"],
			twister: ["8L1"],
			waterpulse: ["8T"],
		},
	},
	heatran: {
		inherit: true,
		learnset: {
			ancientpower: ["8L12"],
			bulldoze: ["8T"],
			crunch: ["8L36", "8S10"],
			darkpulse: ["8T"],
			earthpower: ["8T", "8L46", "8S10"],
			ember: ["8L1"],
			firefang: ["8T", "8L19"],
			flamethrower: ["8T"],
			flashcannon: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irondefense: ["8L6"],
			ironhead: ["8T", "8L27", "8S10"],
			magmastorm: ["8L57", "8S10"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			stealthrock: ["8T"],
			steelbeam: ["8T"],
			stoneedge: ["8T"],
		},
	},
	regigigas: {
		inherit: true,
		learnset: {
			aerialace: ["8T"],
			ancientpower: ["8L19"],
			bulldoze: ["8T", "8L12"],
			crushgrip: ["8L46", "8S10"],
			drainpunch: ["8T"],
			earthpower: ["8T"],
			firepunch: ["8T"],
			gigaimpact: ["8T", "8L57", "8S10"],
			highhorsepower: ["8T"],
			hyperbeam: ["8T"],
			icepunch: ["8T"],
			icywind: ["8T"],
			ironhead: ["8T", "8L36", "8S10"],
			powershift: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T", "8L6"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			zenheadbutt: ["8T", "8L27", "8S10"],
		},
	},
	giratina: {
		inherit: true,
		learnset: {
			aerialace: ["8T"],
			ancientpower: ["8L6"],
			aquatail: ["8T"],
			aurasphere: ["8L27"],
			bulldoze: ["8T"],
			calmmind: ["8T"],
			chargebeam: ["8T"],
			darkpulse: ["8T"],
			dracometeor: ["8T"],
			dragonclaw: ["8L36", "8S10"],
			dragonpulse: ["8L42", "8S10"],
			earthpower: ["8T", "8L55", "8S10"],
			energyball: ["8T"],
			gigaimpact: ["8T"],
			hex: ["8L12"],
			hyperbeam: ["8T"],
			icywind: ["8T"],
			ironhead: ["8T"],
			irontail: ["8T"],
			ominouswind: ["8T"],
			outrage: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T", "8L30"],
			shadowclaw: ["8T", "8L19"],
			shadowforce: ["8L60", "8S10"],
			shadowsneak: ["8L1"],
			stoneedge: ["8T"],
			swift: ["8T"],
			thunderbolt: ["8T"],
		},
	},
	cresselia: {
		inherit: true,
		learnset: {
			calmmind: ["8T"],
			chargebeam: ["8T"],
			confusion: ["8L6"],
			energyball: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icywind: ["8T"],
			lunarblessing: ["8L57", "8S7"],
			moonblast: ["8L46", "8S7"],
			powershift: ["8T"],
			psychic: ["8T", "8L36", "8S7"],
			psychocut: ["8T", "8L19", "8S7"],
			recover: ["8L27"],
			rest: ["8T"],
			shadowball: ["8T"],
			slash: ["8L12"],
			swift: ["8T"],
			tackle: ["8L1"],
			zenheadbutt: ["8T"],
		},
	},
	phione: {
		learnset: {
			acidarmor: ["8L19"],
			bubble: ["8L1"],
			calmmind: ["8T"],
			confusion: ["8L6"],
			dazzlinggleam: ["8T"],
			hydropump: ["8L57"],
			icebeam: ["8T"],
			icywind: ["8T"],
			moonblast: ["8L36"],
			rest: ["8T"],
			swift: ["8T"],
			takeheart: ["8L46"],
			waterpulse: ["8T", "8L12"],
			zenheadbutt: ["8T", "8L27"],
		},
	},
	manaphy: {
		inherit: true,
		learnset: {
			acidarmor: ["8L19"],
			bubble: ["8L1", "8S8"],
			calmmind: ["8T"],
			confusion: ["8L6"],
			dazzlinggleam: ["8T"],
			energyball: ["8T"],
			gigaimpact: ["8T"],
			hydropump: ["8L57"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icywind: ["8T"],
			moonblast: ["8L36", "8S8"],
			psychic: ["8T"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			takeheart: ["8L46"],
			waterpulse: ["8T", "8L12", "8S8"],
			zenheadbutt: ["8T", "8L27", "8S8"],
		},
	},
	darkrai: {
		inherit: true,
		learnset: {
			aerialace: ["8T"],
			calmmind: ["8T"],
			chargebeam: ["8T"],
			darkpulse: ["8T", "8L27", "8S9"],
			darkvoid: ["8L57", "8S9"],
			drainpunch: ["8T"],
			gigaimpact: ["8T"],
			hex: ["8L12", "8S9"],
			hyperbeam: ["8T"],
			hypnosis: ["8L6"],
			icebeam: ["8T"],
			icywind: ["8T"],
			nastyplot: ["8L19"],
			ominouswind: ["8T"],
			poisonjab: ["8T"],
			psychic: ["8T", "8L46", "8S9"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T", "8L36"],
			shadowclaw: ["8T"],
			shadowsneak: ["8L1"],
			sludgebomb: ["8T"],
			snarl: ["8T"],
			swift: ["8T"],
			thunderbolt: ["8T"],
			xscissor: ["8T"],
		},
	},
	shaymin: {
		inherit: true,
		learnset: {
			aerialace: ["8T"],
			airslash: ["8L19", "8S7"],
			babydolleyes: ["8T"],
			dazzlinggleam: ["8T"],
			earthpower: ["8T", "8L46", "8S7"],
			energyball: ["8T", "8L36", "8S7"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			leafage: ["8L1"],
			magicalleaf: ["8T"],
			ominouswind: ["8T"],
			playrough: ["8T"],
			psychic: ["8T"],
			quickattack: ["8L6"],
			recover: ["8L27"],
			rest: ["8T"],
			seedflare: ["8L57", "8S7"],
			sleeppowder: ["8L12"],
			swift: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	arceus: {
		inherit: true,
		learnset: {
			aerialace: ["8T"],
			ancientpower: ["8L12"],
			aquatail: ["8T"],
			bulldoze: ["8T"],
			calmmind: ["8T", "8L19", "8S6"],
			chargebeam: ["8T"],
			confusion: ["8L6"],
			darkpulse: ["8T"],
			dazzlinggleam: ["8T"],
			dracometeor: ["8T"],
			earthpower: ["8T"],
			energyball: ["8T"],
			extrasensory: ["8L36"],
			flamethrower: ["8T"],
			flashcannon: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T", "8L57", "8S6"],
			icebeam: ["8T"],
			icywind: ["8T"],
			ironhead: ["8T"],
			irontail: ["8T"],
			judgment: ["8L46", "8S6"],
			mysticalfire: ["8T"],
			ominouswind: ["8T"],
			outrage: ["8T"],
			poisonjab: ["8T"],
			psychic: ["8T"],
			quickattack: ["8L1"],
			recover: ["8L27", "8S6"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			shadowclaw: ["8T"],
			sludgebomb: ["8T"],
			snarl: ["8T"],
			stealthrock: ["8T"],
			steelbeam: ["8T"],
			stoneedge: ["8T"],
			swift: ["8T"],
			thunderbolt: ["8T"],
			waterpulse: ["8T"],
			xscissor: ["8T"],
			zenheadbutt: ["8T"],
		},
	},
	oshawott: {
		learnset: {
			aerialace: ["8T"],
			aquajet: ["8L6"],
			aquatail: ["8T", "8L34"],
			falseswipe: ["8T"],
			focusenergy: ["8T"],
			hydropump: ["8L43"],
			icebeam: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			slash: ["8L25"],
			swordsdance: ["8L11"],
			tackle: ["8L1"],
			waterpulse: ["8T", "8L18"],
			xscissor: ["8T"],
		},
	},
	dewott: {
		learnset: {
			aerialace: ["8T"],
			aquajet: ["8L6"],
			aquatail: ["8T", "8L34"],
			falseswipe: ["8T"],
			focusenergy: ["8T"],
			hydropump: ["8L43"],
			icebeam: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			slash: ["8L25"],
			swordsdance: ["8L11"],
			tackle: ["8L1"],
			waterpulse: ["8T", "8L18"],
			xscissor: ["8T"],
		},
	},
	samurotthisui: {
		learnset: {
			aerialace: ["8T"],
			aquajet: ["8L6"],
			aquatail: ["8T", "8L34"],
			ceaselessedge: ["8L21"],
			darkpulse: ["8T", "8L40"],
			falseswipe: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hydropump: ["8L43"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			megahorn: ["8T"],
			nightslash: ["8L0"],
			poisonjab: ["8T"],
			psychocut: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			slash: ["8L25"],
			swordsdance: ["8L11"],
			tackle: ["8L1"],
			waterpulse: ["8T", "8L18"],
			xscissor: ["8T"],
		},
	},
	petilil: {
		learnset: {
			absorb: ["8L1"],
			babydolleyes: ["8T"],
			energyball: ["8T", "8L21"],
			leafage: ["8L5"],
			leafstorm: ["8L47"],
			magicalleaf: ["8T"],
			poisonpowder: ["8L15"],
			recover: ["8L37"],
			rest: ["8T"],
			sleeppowder: ["8L29"],
			stunspore: ["8L9"],
		},
	},
	lilliganthisui: {
		learnset: {
			absorb: ["8L1"],
			aerialace: ["8T"],
			babydolleyes: ["8T"],
			closecombat: ["8L57"],
			drainpunch: ["8T", "8L34"],
			energyball: ["8T", "8L21"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			leafage: ["8L5"],
			leafblade: ["8L37"],
			leafstorm: ["8L47"],
			magicalleaf: ["8T"],
			petaldance: ["8L53"],
			poisonjab: ["8T"],
			poisonpowder: ["8L15"],
			recover: ["8L37"],
			rest: ["8T"],
			rocksmash: ["8T", "8L0"],
			sleeppowder: ["8L29"],
			stunspore: ["8L9"],
			victorydance: ["8L42"],
		},
	},
	basculinwhitestriped: {
		learnset: {
			aquajet: ["8L6"],
			aquatail: ["8T"],
			bite: ["8L11"],
			crunch: ["8L25"],
			doubleedge: ["8L43"],
			icebeam: ["8T"],
			icefang: ["8T"],
			icywind: ["8T"],
			rest: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			wavecrash: ["8L34"],
			zenheadbutt: ["8T", "8L18"],
		},
	},
	zoruahisui: {
		learnset: {
			aerialace: ["8T"],
			bittermalice: ["8L18"],
			calmmind: ["8T"],
			darkpulse: ["8T"],
			nastyplot: ["8L43"],
			rest: ["8T"],
			shadowball: ["8T"],
			shadowclaw: ["8T", "8L34"],
			shadowsneak: ["8L1"],
			slash: ["8L25"],
			sludgebomb: ["8T"],
			snarl: ["8T", "8L6"],
			swift: ["8T", "8L11"],
		},
	},
	zoroarkhisui: {
		learnset: {
			aerialace: ["8T"],
			bittermalice: ["8L18"],
			calmmind: ["8T"],
			darkpulse: ["8T"],
			extrasensory: ["8L52"],
			flamethrower: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			nastyplot: ["8L43"],
			ominouswind: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T", "8L40"],
			shadowclaw: ["8T", "8L34"],
			shadowsneak: ["8L1"],
			slash: ["8L25"],
			sludgebomb: ["8T"],
			snarl: ["8T", "8L6"],
			swift: ["8T", "8L11"],
		},
	},
	rufflet: {
		learnset: {
			aerialace: ["8T", "8L6"],
			airslash: ["8L20"],
			bravebird: ["8L43"],
			bulkup: ["8T"],
			doubleedge: ["8L34"],
			ominouswind: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			roost: ["8L25"],
			shadowclaw: ["8T"],
			slash: ["8L18"],
			swift: ["8T"],
			twister: ["8L11"],
			zenheadbutt: ["8T"],
		},
	},
	braviaryhisui: {
		learnset: {
			aerialace: ["8T", "8L6"],
			airslash: ["8L20"],
			bravebird: ["8L43"],
			bulkup: ["8T"],
			dazzlinggleam: ["8T"],
			doubleedge: ["8L34"],
			esperwing: ["8L25"],
			gigaimpact: ["8T"],
			hurricane: ["8L52"],
			hyperbeam: ["8T"],
			mysticalfire: ["8T"],
			ominouswind: ["8T"],
			powershift: ["8T"],
			psychic: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			roost: ["8L25"],
			shadowclaw: ["8T"],
			slash: ["8L18"],
			swift: ["8T"],
			twister: ["8L11"],
			zenheadbutt: ["8T"],
		},
	},
	tornadus: {
		inherit: true,
		learnset: {
			aerialace: ["8T"],
			aircutter: ["8L14"],
			bite: ["8L7"],
			bleakwindstorm: ["8L52", "8S8"],
			bulkup: ["8T"],
			crunch: ["8L41", "8S8"],
			darkpulse: ["8T"],
			extrasensory: ["8L31", "8S8"],
			gigaimpact: ["8T"],
			hurricane: ["8L47", "8S8"],
			hyperbeam: ["8T"],
			icywind: ["8T"],
			irontail: ["8T"],
			nastyplot: ["8L22"],
			psychic: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			sludgebomb: ["8T"],
			tackle: ["8L1"],
			twister: ["8L11"],
		},
	},
	thundurus: {
		inherit: true,
		learnset: {
			bite: ["8L7"],
			bulkup: ["8T"],
			chargebeam: ["8T"],
			crunch: ["8L41", "8S8"],
			darkpulse: ["8T"],
			extrasensory: ["8L31", "8S8"],
			flashcannon: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			nastyplot: ["8L22"],
			powershift: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			sludgebomb: ["8T"],
			spark: ["8L14"],
			tackle: ["8L1"],
			thunder: ["8L47", "8S8"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			twister: ["8L11"],
			wildboltstorm: ["8L52", "8S8"],
			wildcharge: ["8T"],
		},
	},
	landorus: {
		inherit: true,
		learnset: {
			bite: ["8L7"],
			bulkup: ["8T", "8L22"],
			bulldoze: ["8T", "8L14"],
			calmmind: ["8T"],
			crunch: ["8L41", "8S6"],
			earthpower: ["8T", "8L47", "8S6"],
			extrasensory: ["8L31", "8S6"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			outrage: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			sandsearstorm: ["8L52", "8S6"],
			sludgebomb: ["8T"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			twister: ["8L11"],
		},
	},
	sylveon: {
		learnset: {
			babydolleyes: ["8T", "8L18"],
			calmmind: ["8T", "8L34"],
			dazzlinggleam: ["8T"],
			doubleedge: ["8L43"],
			fairywind: ["8L0"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			magicalleaf: ["8T"],
			mimic: ["8L25"],
			mysticalfire: ["8T"],
			playrough: ["8T", "8L25"],
			quickattack: ["8L6"],
			rest: ["8T"],
			rocksmash: ["8T"],
			shadowball: ["8T"],
			swift: ["8T", "8L11"],
			tackle: ["8L1"],
		},
	},
	goomy: {
		learnset: {
			acidarmor: ["8L11"],
			acidspray: ["8L6"],
			bubble: ["8L1"],
			dracometeor: ["8T"],
			dragonpulse: ["8L25"],
			hydropump: ["8L43"],
			irontail: ["8T"],
			outrage: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			shelter: ["8L34"],
			sludgebomb: ["8T"],
			thunderbolt: ["8T"],
			waterpulse: ["8T", "8L18"],
		},
	},
	sliggoohisui: {
		learnset: {
			acidarmor: ["8L11"],
			acidspray: ["8L6"],
			bubble: ["8L1"],
			dracometeor: ["8T"],
			dragonpulse: ["8L25"],
			hydropump: ["8L43"],
			icebeam: ["8T"],
			ironhead: ["8T", "8L25"],
			irontail: ["8T"],
			outrage: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			shelter: ["8L34"],
			sludgebomb: ["8T"],
			steelbeam: ["8T"],
			thunderbolt: ["8T"],
			waterpulse: ["8T", "8L18"],
		},
	},
	goodrahisui: {
		learnset: {
			acidarmor: ["8L11"],
			acidspray: ["8L6"],
			bubble: ["8L1"],
			bulldoze: ["8T"],
			dracometeor: ["8T"],
			dragonpulse: ["8L25"],
			firepunch: ["8T"],
			flamethrower: ["8T"],
			gigaimpact: ["8T"],
			hydropump: ["8L43"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			ironhead: ["8T", "8L25"],
			irontail: ["8T"],
			outrage: ["8T"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shelter: ["8L34"],
			sludgebomb: ["8T"],
			steelbeam: ["8T"],
			thunderbolt: ["8T"],
			thunderpunch: ["8T"],
			waterpulse: ["8T", "8L18"],
		},
	},
	bergmite: {
		learnset: {
			bite: ["8L15"],
			blizzard: ["8L37"],
			crunch: ["8L29"],
			doubleedge: ["8L47"],
			flashcannon: ["8T"],
			iceball: ["8T"],
			icebeam: ["8T"],
			icefang: ["8T"],
			iceshard: ["8L9"],
			icywind: ["8T"],
			irondefense: ["8L21"],
			powdersnow: ["8L5"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			waterpulse: ["8T"],
		},
	},
	avalugghisui: {
		learnset: {
			bite: ["8L15"],
			blizzard: ["8L37"],
			bulldoze: ["8T"],
			crunch: ["8L29"],
			doubleedge: ["8L47"],
			earthpower: ["8T", "8L29"],
			flashcannon: ["8T"],
			gigaimpact: ["8T"],
			highhorsepower: ["8T"],
			hyperbeam: ["8T"],
			iceball: ["8T"],
			icebeam: ["8T"],
			icefang: ["8T"],
			iceshard: ["8L9"],
			icywind: ["8T"],
			irondefense: ["8L21"],
			ironhead: ["8T"],
			mountaingale: ["8L37"],
			powdersnow: ["8L5"],
			powershift: ["8T"],
			rest: ["8T"],
			rockslide: ["8T", "8L0"],
			rocksmash: ["8T"],
			stealthrock: ["8T"],
			stoneedge: ["8T"],
			tackle: ["8L1"],
			waterpulse: ["8T"],
		},
	},
	rowlet: {
		learnset: {
			aerialace: ["8T", "8L18"],
			airslash: ["8L25"],
			falseswipe: ["8T"],
			gust: ["8L1"],
			leafage: ["8L6"],
			leafblade: ["8L34"],
			leafstorm: ["8L43"],
			magicalleaf: ["8T", "8L21"],
			psychocut: ["8T"],
			rest: ["8T"],
			roost: ["8L11"],
			shadowclaw: ["8T"],
			swift: ["8T"],
		},
	},
	dartrix: {
		learnset: {
			aerialace: ["8T", "8L18"],
			airslash: ["8L25"],
			energyball: ["8T"],
			falseswipe: ["8T"],
			gust: ["8L1"],
			leafage: ["8L6"],
			leafblade: ["8L34"],
			leafstorm: ["8L43"],
			magicalleaf: ["8T", "8L21"],
			psychocut: ["8T"],
			rest: ["8T"],
			roost: ["8L11"],
			shadowclaw: ["8T"],
			swift: ["8T"],
		},
	},
	decidueyehisui: {
		learnset: {
			aerialace: ["8T", "8L18"],
			airslash: ["8L25"],
			aurasphere: ["8L30"],
			bravebird: ["8L40"],
			bulkup: ["8T"],
			energyball: ["8T"],
			falseswipe: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			gust: ["8L1"],
			hyperbeam: ["8T"],
			leafage: ["8L6"],
			leafblade: ["8L34"],
			leafstorm: ["8L43"],
			magicalleaf: ["8T", "8L21"],
			psychocut: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T", "8L0"],
			roost: ["8L11"],
			shadowclaw: ["8T"],
			spikes: ["8T"],
			swift: ["8T"],
			triplearrows: ["8L34"],
		},
	},
	wyrdeer: {
		learnset: {
			bulldoze: ["8T"],
			calmmind: ["8T", "8L15"],
			chargebeam: ["8T"],
			confusion: ["8L5"],
			doubleedge: ["8L47"],
			energyball: ["8T"],
			extrasensory: ["8L29"],
			gigaimpact: ["8T"],
			highhorsepower: ["8T"],
			hyperbeam: ["8T"],
			hypnosis: ["8L9"],
			irontail: ["8T"],
			megahorn: ["8T"],
			psychic: ["8T"],
			psyshieldbash: ["8L21"],
			rest: ["8T"],
			shadowball: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			thunderbolt: ["8T"],
			wildcharge: ["8T"],
			zenheadbutt: ["8T", "8L37"],
		},
	},
	kleavor: {
		learnset: {
			aerialace: ["8T", "8L11"],
			airslash: ["8L18"],
			calmmind: ["8T"],
			closecombat: ["8L43"],
			doublehit: ["8L14"],
			falseswipe: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			ominouswind: ["8T"],
			psychocut: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			silverwind: ["8L6"],
			stealthrock: ["8T", "8L14"],
			stoneaxe: ["8L29"],
			stoneedge: ["8T"],
			swift: ["8T"],
			swordsdance: ["8L25"],
			xscissor: ["8T", "8L34"],
		},
	},
	ursaluna: {
		learnset: {
			aerialace: ["8T"],
			babydolleyes: ["8T", "8L6"],
			bulkup: ["8T"],
			bulldoze: ["8T", "8L11"],
			doubleedge: ["8L43"],
			earthpower: ["8T"],
			firepunch: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			headlongrush: ["8L43"],
			highhorsepower: ["8T", "8L34"],
			hyperbeam: ["8T"],
			icepunch: ["8T"],
			playrough: ["8T", "8L25"],
			rest: ["8T"],
			rockslide: ["8T"],
			rocksmash: ["8T"],
			shadowclaw: ["8T"],
			slash: ["8L18"],
			stoneedge: ["8T"],
			swift: ["8T"],
			tackle: ["8L1"],
			thunderpunch: ["8T"],
		},
	},
	basculegion: {
		learnset: {
			aquajet: ["8L6"],
			aquatail: ["8T"],
			bite: ["8L11"],
			calmmind: ["8T"],
			crunch: ["8L25"],
			doubleedge: ["8L43"],
			gigaimpact: ["8T"],
			hex: ["8L11"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icefang: ["8T"],
			icywind: ["8T"],
			ominouswind: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			shadowball: ["8T", "8L25"],
			swift: ["8T"],
			tackle: ["8L1"],
			waterpulse: ["8T"],
			wavecrash: ["8L34"],
			zenheadbutt: ["8T", "8L18"],
		},
	},
	basculegionf: {
		learnset: {
			aquajet: ["8L6"],
			aquatail: ["8T"],
			bite: ["8L11"],
			calmmind: ["8T"],
			crunch: ["8L25"],
			doubleedge: ["8L43"],
			gigaimpact: ["8T"],
			hex: ["8L11"],
			hyperbeam: ["8T"],
			icebeam: ["8T"],
			icefang: ["8T"],
			icywind: ["8T"],
			ominouswind: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			shadowball: ["8T", "8L25"],
			swift: ["8T"],
			tackle: ["8L1"],
			waterpulse: ["8T"],
			wavecrash: ["8L34"],
			zenheadbutt: ["8T", "8L18"],
		},
	},
	sneasler: {
		learnset: {
			aerialace: ["8T"],
			bulkup: ["8T"],
			calmmind: ["8T"],
			closecombat: ["8L43"],
			direclaw: ["8L11"],
			drainpunch: ["8T"],
			falseswipe: ["8T"],
			focusenergy: ["8T"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irontail: ["8T"],
			poisonjab: ["8T", "8L25"],
			powershift: ["8T"],
			quickattack: ["8L1"],
			rest: ["8T"],
			rocksmash: ["8T", "8L6"],
			shadowball: ["8T"],
			shadowclaw: ["8T"],
			slash: ["8L18"],
			snarl: ["8T"],
			swift: ["8T", "8L11"],
			swordsdance: ["8L34"],
			xscissor: ["8T"],
		},
	},
	overqwil: {
		learnset: {
			aquatail: ["8T", "8L37"],
			barbbarrage: ["8L15"],
			darkpulse: ["8T", "8L26"],
			doubleedge: ["8L47"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			iceball: ["8T"],
			icebeam: ["8T"],
			icywind: ["8T"],
			pinmissile: ["8L9"],
			poisonjab: ["8T", "8L29"],
			poisonsting: ["8L1"],
			rest: ["8T"],
			selfdestruct: ["8L57"],
			shadowball: ["8T"],
			sludgebomb: ["8T"],
			spikes: ["8T", "8L5"],
			swift: ["8T"],
			waterpulse: ["8T", "8L21"],
		},
	},
	enamorus: {
		inherit: true,
		learnset: {
			bite: ["8L7"],
			calmmind: ["8T"],
			crunch: ["8L41", "8S0"],
			dazzlinggleam: ["8T"],
			drainingkiss: ["8L14"],
			earthpower: ["8T"],
			extrasensory: ["8L31", "8S0"],
			gigaimpact: ["8T"],
			hyperbeam: ["8T"],
			irondefense: ["8L22"],
			moonblast: ["8L47", "8S0"],
			mysticalfire: ["8T"],
			playrough: ["8T"],
			powershift: ["8T"],
			psychic: ["8T"],
			rest: ["8T"],
			rocksmash: ["8T"],
			sludgebomb: ["8T"],
			springtidestorm: ["8L52", "8S0"],
			tackle: ["8L1"],
			twister: ["8L11"],
			zenheadbutt: ["8T"],
		},
	},
};
